import * as Types from './schemas';

export type MarkErrorGroupAsViewedMutationVariables = Types.Exact<{
  error_secure_id: Types.Scalars['String']['input'];
  viewed: Types.Scalars['Boolean']['input'];
}>;

export type MarkErrorGroupAsViewedMutation = {
  __typename?: 'Mutation';
  markErrorGroupAsViewed?: { __typename?: 'ErrorGroup'; secure_id: string; viewed?: boolean | null } | null;
};

export type MarkSessionAsViewedMutationVariables = Types.Exact<{
  secure_id: Types.Scalars['String']['input'];
  viewed: Types.Scalars['Boolean']['input'];
}>;

export type MarkSessionAsViewedMutation = {
  __typename?: 'Mutation';
  markSessionAsViewed?: { __typename?: 'Session'; secure_id: string; viewed?: boolean | null } | null;
};

export type UpdateErrorGroupStateMutationVariables = Types.Exact<{
  secure_id: Types.Scalars['String']['input'];
  state: Types.ErrorState;
  snoozed_until?: Types.InputMaybe<Types.Scalars['Timestamp']['input']>;
}>;

export type UpdateErrorGroupStateMutation = {
  __typename?: 'Mutation';
  updateErrorGroupState?: {
    __typename?: 'ErrorGroup';
    secure_id: string;
    state: Types.ErrorState;
    snoozed_until?: any | null;
  } | null;
};

export type AddIntegrationToProjectMutationVariables = Types.Exact<{
  integration_type?: Types.InputMaybe<Types.IntegrationType>;
  project_id: Types.Scalars['ID']['input'];
  code: Types.Scalars['String']['input'];
}>;

export type AddIntegrationToProjectMutation = { __typename?: 'Mutation'; addIntegrationToProject: boolean };

export type RemoveIntegrationFromProjectMutationVariables = Types.Exact<{
  integration_type?: Types.InputMaybe<Types.IntegrationType>;
  project_id: Types.Scalars['ID']['input'];
}>;

export type RemoveIntegrationFromProjectMutation = { __typename?: 'Mutation'; removeIntegrationFromProject: boolean };

export type AddIntegrationToWorkspaceMutationVariables = Types.Exact<{
  integration_type?: Types.InputMaybe<Types.IntegrationType>;
  workspace_id: Types.Scalars['ID']['input'];
  code: Types.Scalars['String']['input'];
}>;

export type AddIntegrationToWorkspaceMutation = { __typename?: 'Mutation'; addIntegrationToWorkspace: boolean };

export type RemoveIntegrationFromWorkspaceMutationVariables = Types.Exact<{
  integration_type: Types.IntegrationType;
  workspace_id: Types.Scalars['ID']['input'];
}>;

export type RemoveIntegrationFromWorkspaceMutation = {
  __typename?: 'Mutation';
  removeIntegrationFromWorkspace: boolean;
};

export type SubmitRegistrationFormMutationVariables = Types.Exact<{
  workspace_id: Types.Scalars['ID']['input'];
  team_size: Types.Scalars['String']['input'];
  role: Types.Scalars['String']['input'];
  use_case: Types.Scalars['String']['input'];
  heard_about: Types.Scalars['String']['input'];
  pun?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type SubmitRegistrationFormMutation = { __typename?: 'Mutation'; submitRegistrationForm?: boolean | null };

export type EditProjectSettingsMutationVariables = Types.Exact<{
  projectId: Types.Scalars['StringID']['input'];
  excluded_users?: Types.InputMaybe<Types.Scalars['StringArray']['input']>;
  error_filters?: Types.InputMaybe<Types.Scalars['StringArray']['input']>;
  error_json_paths?: Types.InputMaybe<Types.Scalars['StringArray']['input']>;
  filter_chrome_extension?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  rage_click_window_seconds?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  rage_click_radius_pixels?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  rage_click_count?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  filterSessionsWithoutError?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  autoResolveStaleErrorsDayInterval?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  sampling?: Types.InputMaybe<Types.SamplingInput>;
}>;

export type EditProjectSettingsMutation = {
  __typename?: 'Mutation';
  editProjectSettings?: {
    __typename?: 'AllProjectSettings';
    id: string;
    name: string;
    billing_email?: string | null;
    excluded_users?: any | null;
    error_filters?: any | null;
    error_json_paths?: any | null;
    filter_chrome_extension?: boolean | null;
    rage_click_window_seconds?: number | null;
    rage_click_radius_pixels?: number | null;
    rage_click_count?: number | null;
    filterSessionsWithoutError: boolean;
    autoResolveStaleErrorsDayInterval: number;
    sampling: {
      __typename?: 'Sampling';
      session_sampling_rate: number;
      error_sampling_rate: number;
      log_sampling_rate: number;
      trace_sampling_rate: number;
      metric_sampling_rate: number;
      session_minute_rate_limit?: any | null;
      error_minute_rate_limit?: any | null;
      log_minute_rate_limit?: any | null;
      trace_minute_rate_limit?: any | null;
      metric_minute_rate_limit?: any | null;
      session_exclusion_query?: string | null;
      error_exclusion_query?: string | null;
      log_exclusion_query?: string | null;
      trace_exclusion_query?: string | null;
      metric_exclusion_query?: string | null;
    };
  } | null;
};

export type CreateAlertMutationVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  name: Types.Scalars['String']['input'];
  message_content?: Types.InputMaybe<Types.Scalars['String']['input']>;
  product_type: Types.ProductType;
  function_type: Types.MetricAggregator;
  population_function_type?: Types.InputMaybe<Types.MetricAggregator>;
  population_query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  population_window?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  function_column?: Types.InputMaybe<Types.Scalars['String']['input']>;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  group_by_key?: Types.InputMaybe<Types.Scalars['String']['input']>;
  group_by_keys?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  default?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  threshold_value?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  threshold_window?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  threshold_cooldown?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  threshold_type?: Types.InputMaybe<Types.ThresholdType>;
  threshold_condition?: Types.InputMaybe<Types.ThresholdCondition>;
  destinations: Array<Types.AlertDestinationInput> | Types.AlertDestinationInput;
  sql?: Types.InputMaybe<Types.Scalars['String']['input']>;
  auto_investigation_enabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  investigation_cooldown?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  permission_mode?: Types.InputMaybe<Types.Scalars['String']['input']>;
  investigation_repositories?: Types.InputMaybe<Types.Scalars['StringArray']['input']>;
  investigation_prompt?: Types.InputMaybe<Types.Scalars['String']['input']>;
  evaluation_delay_seconds?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  hide_graph?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  warn_threshold_value?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  no_data_behavior?: Types.InputMaybe<Types.NoDataBehavior>;
  send_resolved_alert?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  tags?: Types.InputMaybe<Types.Scalars['StringMap']['input']>;
}>;

export type CreateAlertMutation = {
  __typename?: 'Mutation';
  createAlert?: { __typename?: 'Alert'; id: string; name: string; product_type: Types.ProductType } | null;
};

export type UpdateAlertMutationVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  alert_id: Types.Scalars['ID']['input'];
  name: Types.Scalars['String']['input'];
  message_content?: Types.InputMaybe<Types.Scalars['String']['input']>;
  product_type: Types.ProductType;
  function_type: Types.MetricAggregator;
  population_function_type?: Types.InputMaybe<Types.MetricAggregator>;
  population_query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  population_window?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  function_column?: Types.InputMaybe<Types.Scalars['String']['input']>;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  group_by_key?: Types.InputMaybe<Types.Scalars['String']['input']>;
  group_by_keys?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  threshold_value?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  threshold_window?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  threshold_cooldown?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  threshold_type?: Types.InputMaybe<Types.ThresholdType>;
  threshold_condition?: Types.InputMaybe<Types.ThresholdCondition>;
  destinations?: Types.InputMaybe<Array<Types.AlertDestinationInput> | Types.AlertDestinationInput>;
  sql?: Types.InputMaybe<Types.Scalars['String']['input']>;
  auto_investigation_enabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  investigation_cooldown?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  permission_mode?: Types.InputMaybe<Types.Scalars['String']['input']>;
  investigation_repositories?: Types.InputMaybe<Types.Scalars['StringArray']['input']>;
  investigation_prompt?: Types.InputMaybe<Types.Scalars['String']['input']>;
  evaluation_delay_seconds?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  hide_graph?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  warn_threshold_value?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  no_data_behavior?: Types.InputMaybe<Types.NoDataBehavior>;
  send_resolved_alert?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  tags?: Types.InputMaybe<Types.Scalars['StringMap']['input']>;
}>;

export type UpdateAlertMutation = {
  __typename?: 'Mutation';
  updateAlert?: { __typename?: 'Alert'; id: string; name: string; product_type: Types.ProductType } | null;
};

export type UpdateAlertDisabledMutationVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  alert_id: Types.Scalars['ID']['input'];
  disabled: Types.Scalars['Boolean']['input'];
}>;

export type UpdateAlertDisabledMutation = { __typename?: 'Mutation'; updateAlertDisabled: boolean };

export type DeleteAlertMutationVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  alert_id: Types.Scalars['ID']['input'];
}>;

export type DeleteAlertMutation = { __typename?: 'Mutation'; deleteAlert: boolean };

export type TestAlertConfigurationMutationVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  alert_configuration: Types.AlertConfigurationInput;
}>;

export type TestAlertConfigurationMutation = { __typename?: 'Mutation'; testAlertConfiguration: boolean };

export type UpdateSessionIsPublicMutationVariables = Types.Exact<{
  session_secure_id: Types.Scalars['String']['input'];
  is_public: Types.Scalars['Boolean']['input'];
}>;

export type UpdateSessionIsPublicMutation = {
  __typename?: 'Mutation';
  updateSessionIsPublic?: { __typename?: 'Session'; secure_id: string; is_public: boolean } | null;
};

export type UpdateErrorGroupIsPublicMutationVariables = Types.Exact<{
  error_group_secure_id: Types.Scalars['String']['input'];
  is_public: Types.Scalars['Boolean']['input'];
}>;

export type UpdateErrorGroupIsPublicMutation = {
  __typename?: 'Mutation';
  updateErrorGroupIsPublic?: { __typename?: 'ErrorGroup'; secure_id: string; is_public: boolean } | null;
};

export type UpdateAllowMeterOverageMutationVariables = Types.Exact<{
  workspace_id: Types.Scalars['ID']['input'];
  allow_meter_overage: Types.Scalars['Boolean']['input'];
}>;

export type UpdateAllowMeterOverageMutation = {
  __typename?: 'Mutation';
  updateAllowMeterOverage?: { __typename?: 'Workspace'; id: string; allow_meter_overage: boolean } | null;
};

export type SyncSlackIntegrationMutationVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
}>;

export type SyncSlackIntegrationMutation = {
  __typename?: 'Mutation';
  syncSlackIntegration: { __typename?: 'SlackSyncResponse'; success: boolean; newChannelsAddedCount: number };
};

export type DeleteSessionsMutationVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
  params: Types.QueryInput;
  sessionCount: Types.Scalars['Int']['input'];
}>;

export type DeleteSessionsMutation = { __typename?: 'Mutation'; deleteSessions: boolean };

export type ExportSessionMutationVariables = Types.Exact<{
  session_secure_id: Types.Scalars['String']['input'];
}>;

export type ExportSessionMutation = { __typename?: 'Mutation'; exportSession: boolean };

export type UpdateIntegrationProjectSettingsMutationVariables = Types.Exact<{
  workspace_id: Types.Scalars['ID']['input'];
  integration_type: Types.IntegrationType;
  project_mappings: Array<Types.IntegrationProjectMappingInput> | Types.IntegrationProjectMappingInput;
}>;

export type UpdateIntegrationProjectSettingsMutation = {
  __typename?: 'Mutation';
  updateIntegrationProjectMappings: boolean;
};

export type EditServiceGithubSettingsMutationVariables = Types.Exact<{
  id: Types.Scalars['Int64ID']['input'];
  project_id: Types.Scalars['ID']['input'];
  github_repo_path?: Types.InputMaybe<Types.Scalars['String']['input']>;
  build_prefix?: Types.InputMaybe<Types.Scalars['String']['input']>;
  github_prefix?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type EditServiceGithubSettingsMutation = {
  __typename?: 'Mutation';
  editServiceGithubSettings?: {
    __typename?: 'Service';
    id: any;
    projectID: string;
    name: string;
    status: Types.ServiceStatus;
    githubRepoPath?: string | null;
    buildPrefix?: string | null;
    githubPrefix?: string | null;
    errorDetails?: Array<string> | null;
  } | null;
};

export type UpsertSlackChannelMutationVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
  name: Types.Scalars['String']['input'];
}>;

export type UpsertSlackChannelMutation = {
  __typename?: 'Mutation';
  upsertSlackChannel: {
    __typename?: 'SanitizedSlackChannel';
    webhook_channel?: string | null;
    webhook_channel_id?: string | null;
  };
};

export type TestErrorEnhancementMutationVariables = Types.Exact<{
  error_object_id: Types.Scalars['Int64ID']['input'];
  github_repo_path: Types.Scalars['String']['input'];
  github_prefix?: Types.InputMaybe<Types.Scalars['String']['input']>;
  build_prefix?: Types.InputMaybe<Types.Scalars['String']['input']>;
  save_error?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type TestErrorEnhancementMutation = {
  __typename?: 'Mutation';
  testErrorEnhancement?: {
    __typename?: 'ErrorObject';
    id: any;
    type: string;
    serviceName?: string | null;
    serviceVersion?: string | null;
    stack_trace: string;
    structured_stack_trace: Array<{
      __typename?: 'ErrorTrace';
      columnNumber?: number | null;
      enhancementSource?: Types.EnhancementSource | null;
      enhancementVersion?: string | null;
      error?: string | null;
      externalLink?: string | null;
      fileName?: string | null;
      functionName?: string | null;
      lineContent?: string | null;
      lineNumber?: number | null;
      linesAfter?: string | null;
      linesBefore?: string | null;
    } | null>;
  } | null;
};

export type DeleteSavedSegmentMutationVariables = Types.Exact<{
  segment_id: Types.Scalars['ID']['input'];
}>;

export type DeleteSavedSegmentMutation = { __typename?: 'Mutation'; deleteSavedSegment?: boolean | null };

export type EditSavedSegmentMutationVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  id: Types.Scalars['ID']['input'];
  query: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
  entity_type: Types.SavedSegmentEntityType;
  advanced_search_params?: Types.InputMaybe<Types.AdvancedSearchParamsInput>;
}>;

export type EditSavedSegmentMutation = { __typename?: 'Mutation'; editSavedSegment?: boolean | null };

export type CreateSavedSegmentMutationVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  name: Types.Scalars['String']['input'];
  query: Types.Scalars['String']['input'];
  entity_type: Types.SavedSegmentEntityType;
  advanced_search_params?: Types.InputMaybe<Types.AdvancedSearchParamsInput>;
}>;

export type CreateSavedSegmentMutation = {
  __typename?: 'Mutation';
  createSavedSegment?: { __typename?: 'SavedSegment'; name: string; id: string } | null;
};

export type UpsertVisualizationMutationVariables = Types.Exact<{
  visualization: Types.VisualizationInput;
}>;

export type UpsertVisualizationMutation = { __typename?: 'Mutation'; upsertVisualization: string };

export type DeleteVisualizationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type DeleteVisualizationMutation = { __typename?: 'Mutation'; deleteVisualization: boolean };

export type UpsertGraphMutationVariables = Types.Exact<{
  graph: Types.GraphInput;
}>;

export type UpsertGraphMutation = {
  __typename?: 'Mutation';
  upsertGraph: {
    __typename?: 'Graph';
    id: string;
    type: string;
    title: string;
    productType: Types.ProductType;
    query: string;
    groupByKeys?: any | null;
    bucketByKey?: string | null;
    bucketCount?: number | null;
    limit?: number | null;
    limitFunctionType?: Types.MetricAggregator | null;
    limitMetric?: string | null;
    display?: string | null;
    comparisonMode?: string | null;
    strictOrder?: boolean | null;
    breakdownBy?: any | null;
    breakdownLimit?: number | null;
    nullHandling?: string | null;
    showExemplars?: boolean | null;
    exemplarScaleMode?: string | null;
    sql?: string | null;
    heatmapSecureSessionId?: string | null;
    heatmapSessionTimestamp?: any | null;
    funnelSteps?: Array<{ __typename?: 'FunnelStep'; title: string; query: string }> | null;
    expressions: Array<{ __typename?: 'MetricExpression'; aggregator: Types.MetricAggregator; column: string }>;
  };
};

export type DeleteGraphMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type DeleteGraphMutation = { __typename?: 'Mutation'; deleteGraph: boolean };

export type CreateCloudflareProxyMutationVariables = Types.Exact<{
  workspace_id: Types.Scalars['ID']['input'];
  proxy_subdomain: Types.Scalars['String']['input'];
}>;

export type CreateCloudflareProxyMutation = { __typename?: 'Mutation'; createCloudflareProxy: string };

export type AgentPromptMutationVariables = Types.Exact<{
  input: Types.AgentPromptInput;
}>;

export type AgentPromptMutation = {
  __typename?: 'Mutation';
  agentPrompt: { __typename?: 'AgentMessage'; conversation_id: any; text: string; turn: number; is_final: boolean };
};

export type FlagCleanupPromptMutationVariables = Types.Exact<{
  input: Types.FlagCleanupPromptInput;
}>;

export type FlagCleanupPromptMutation = {
  __typename?: 'Mutation';
  flagCleanupPrompt: {
    __typename?: 'AgentMessage';
    conversation_id: any;
    text: string;
    turn: number;
    is_final: boolean;
  };
};

export type PricingConciergePromptMutationVariables = Types.Exact<{
  input: Types.PricingConciergePromptInput;
}>;

export type PricingConciergePromptMutation = {
  __typename?: 'Mutation';
  pricingConciergePrompt: {
    __typename?: 'AgentMessage';
    conversation_id: any;
    text: string;
    turn: number;
    is_final: boolean;
  };
};

export type StopAgentMutationVariables = Types.Exact<{
  conversation_id: Types.Scalars['StringID']['input'];
}>;

export type StopAgentMutation = { __typename?: 'Mutation'; stopAgent: boolean };

export type UpsertVegaSlackConfigurationMutationVariables = Types.Exact<{
  input: Types.VegaSlackConfigurationInput;
}>;

export type UpsertVegaSlackConfigurationMutation = {
  __typename?: 'Mutation';
  upsertVegaSlackConfiguration: {
    __typename?: 'VegaSlackConfiguration';
    id: string;
    admin_id: number;
    permission_mode?: string | null;
    investigation_prompt?: string | null;
    investigation_project_id?: string | null;
    investigation_repositories?: any | null;
  };
};

export type UpsertVegaProjectConfigurationMutationVariables = Types.Exact<{
  input: Types.VegaProjectConfigurationInput;
}>;

export type UpsertVegaProjectConfigurationMutation = {
  __typename?: 'Mutation';
  upsertVegaProjectConfiguration: {
    __typename?: 'VegaProjectConfiguration';
    id: string;
    project_id: number;
    pull_request_title_prefix: string;
    pull_request_bot_identity_workflows: Array<Types.VegaPullRequestBotIdentityWorkflow>;
  };
};

export type CreateQueryFilterRuleMutationVariables = Types.Exact<{
  input: Types.CreateQueryFilterRuleInput;
}>;

export type CreateQueryFilterRuleMutation = {
  __typename?: 'Mutation';
  createQueryFilterRule: {
    __typename?: 'QueryFilterRule';
    id: any;
    rule_name: string;
    is_rule_enabled: boolean;
    product_type: Types.ProductType;
    project_id: string;
    query: string;
    filter_operation: Types.FilterOperationType;
    filter_operation_rate: number;
    attributes: Array<string>;
    created_at: any;
    updated_at: any;
  };
};

export type UpdateQueryFilterRuleMutationVariables = Types.Exact<{
  input: Types.UpdateQueryFilterRuleInput;
}>;

export type UpdateQueryFilterRuleMutation = {
  __typename?: 'Mutation';
  updateQueryFilterRule: {
    __typename?: 'QueryFilterRule';
    id: any;
    rule_name: string;
    is_rule_enabled: boolean;
    product_type: Types.ProductType;
    project_id: string;
    query: string;
    filter_operation: Types.FilterOperationType;
    filter_operation_rate: number;
    attributes: Array<string>;
    created_at: any;
    updated_at: any;
  };
};

export type DeleteQueryFilterRuleMutationVariables = Types.Exact<{
  input: Types.DeleteQueryFilterRuleInput;
}>;

export type DeleteQueryFilterRuleMutation = { __typename?: 'Mutation'; deleteQueryFilterRule: boolean };

export type UpdateFilterSettingsMutationVariables = Types.Exact<{
  input: Types.UpdateFilterSettingsInput;
}>;

export type UpdateFilterSettingsMutation = {
  __typename?: 'Mutation';
  updateFilterSettings: {
    __typename?: 'FilterSettings';
    filter_rules?: {
      __typename?: 'ProjectFilterRules';
      error_filter_rules_order: Array<string>;
      log_filter_rules_order: Array<string>;
      metric_filter_rules_order: Array<string>;
      session_filter_rules_order: Array<string>;
      trace_filter_rules_order: Array<string>;
    } | null;
    sampling?: {
      __typename?: 'Sampling';
      session_sampling_rate: number;
      error_sampling_rate: number;
      log_sampling_rate: number;
      trace_sampling_rate: number;
      metric_sampling_rate: number;
      session_minute_rate_limit?: any | null;
      error_minute_rate_limit?: any | null;
      log_minute_rate_limit?: any | null;
      trace_minute_rate_limit?: any | null;
      metric_minute_rate_limit?: any | null;
      session_exclusion_query?: string | null;
      error_exclusion_query?: string | null;
      log_exclusion_query?: string | null;
      trace_exclusion_query?: string | null;
      metric_exclusion_query?: string | null;
    } | null;
  };
};

export type ShareConversationMutationVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  conversation_id: Types.Scalars['StringID']['input'];
}>;

export type ShareConversationMutation = { __typename?: 'Mutation'; shareConversation: boolean };

export type TagConversationMutationVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  conversation_id: Types.Scalars['StringID']['input'];
  key: Types.Scalars['String']['input'];
  value: Types.Scalars['String']['input'];
}>;

export type TagConversationMutation = { __typename?: 'Mutation'; tagConversation: boolean };

export type SignAiTermsRecordMutationVariables = Types.Exact<{
  enabled: Types.Scalars['Boolean']['input'];
}>;

export type SignAiTermsRecordMutation = { __typename?: 'Mutation'; signAiTermsRecord: boolean };

export type CreateJiraIssueForAlertMutationVariables = Types.Exact<{
  alertID: Types.Scalars['ID']['input'];
  input: Types.JiraIssueCreateInput;
}>;

export type CreateJiraIssueForAlertMutation = {
  __typename?: 'Mutation';
  createJiraIssueForAlert?: {
    __typename?: 'JiraIssueCreateResult';
    id: string;
    issueKey: string;
    issueUrl: string;
    createdBy: string;
    createdAt: any;
  } | null;
};

export type CreateJiraIssueForErrorGroupMutationVariables = Types.Exact<{
  errorGroupSecureID: Types.Scalars['String']['input'];
  input: Types.JiraIssueCreateInput;
}>;

export type CreateJiraIssueForErrorGroupMutation = {
  __typename?: 'Mutation';
  createJiraIssueForErrorGroup?: {
    __typename?: 'JiraIssueCreateResult';
    id: string;
    issueKey: string;
    issueUrl: string;
    createdBy: string;
    createdAt: any;
  } | null;
};

export type CreateJiraIssueForSessionMutationVariables = Types.Exact<{
  sessionSecureID: Types.Scalars['String']['input'];
  input: Types.JiraIssueCreateInput;
}>;

export type CreateJiraIssueForSessionMutation = {
  __typename?: 'Mutation';
  createJiraIssueForSession?: {
    __typename?: 'JiraIssueCreateResult';
    id: string;
    issueKey: string;
    issueUrl: string;
    createdBy: string;
    createdAt: any;
  } | null;
};

export type ExperimentHypothesisBuilderAssistMutationVariables = Types.Exact<{
  input: Types.ExperimentHypothesisBuilderAssistInput;
}>;

export type ExperimentHypothesisBuilderAssistMutation = {
  __typename?: 'Mutation';
  experiment_hypothesis_builder_assist: {
    __typename?: 'AgentMessage';
    conversation_id: any;
    text: string;
    turn: number;
    is_final: boolean;
  };
};

export type EditServiceSettingsMutationVariables = Types.Exact<{
  service_id: Types.Scalars['Int64ID']['input'];
  project_id: Types.Scalars['StringID']['input'];
  input: Types.EditServiceSettingsInput;
}>;

export type EditServiceSettingsMutation = {
  __typename?: 'Mutation';
  editServiceSettings?: {
    __typename?: 'ServiceSettings';
    serviceID: any;
    projectID: string;
    rootSpanFilter?: string | null;
  } | null;
};

export type SessionPayloadFragmentFragment = {
  __typename?: 'SessionPayload';
  events: Array<any | null>;
  last_user_interaction_time: any;
  errors: Array<{
    __typename?: 'ErrorObject';
    id: any;
    error_group_secure_id: string;
    event: Array<string | null>;
    type: string;
    url: string;
    source?: string | null;
    stack_trace: string;
    timestamp: any;
    payload?: string | null;
    request_id?: string | null;
    structured_stack_trace: Array<{
      __typename?: 'ErrorTrace';
      fileName?: string | null;
      lineNumber?: number | null;
      functionName?: string | null;
      columnNumber?: number | null;
    } | null>;
  } | null>;
  rage_clicks: Array<{ __typename?: 'RageClickEvent'; start_timestamp: any; end_timestamp: any; total_clicks: number }>;
  session_comments: Array<{
    __typename?: 'SessionComment';
    id: string;
    timestamp?: number | null;
    session_id: number;
    session_secure_id: string;
    created_at: any;
    updated_at: any;
    project_id: string;
    text: string;
    x_coordinate?: number | null;
    y_coordinate?: number | null;
    type: Types.SessionCommentType;
    metadata?: any | null;
    author?: {
      __typename?: 'SanitizedAdmin';
      id: string;
      name?: string | null;
      email: string;
      photo_url?: string | null;
    } | null;
    attachments: Array<{
      __typename?: 'ExternalAttachment';
      integration_type: Types.IntegrationType;
      external_id: string;
      title?: string | null;
    } | null>;
  } | null>;
};

export type GetNetworkHistogramQueryVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
  params: Types.NetworkHistogramParamsInput;
}>;

export type GetNetworkHistogramQuery = {
  __typename?: 'Query';
  network_histogram?: {
    __typename?: 'CategoryHistogramPayload';
    buckets: Array<{ __typename?: 'CategoryHistogramBucket'; category: string; count: number }>;
  } | null;
};

export type GetSessionPayloadQueryVariables = Types.Exact<{
  session_secure_id: Types.Scalars['String']['input'];
  skip_events: Types.Scalars['Boolean']['input'];
}>;

export type GetSessionPayloadQuery = {
  __typename?: 'Query';
  events?: Array<any | null> | null;
  errors?: Array<{
    __typename?: 'ErrorObject';
    id: any;
    error_group_secure_id: string;
    event: Array<string | null>;
    type: string;
    url: string;
    source?: string | null;
    stack_trace: string;
    timestamp: any;
    payload?: string | null;
    request_id?: string | null;
    structured_stack_trace: Array<{
      __typename?: 'ErrorTrace';
      fileName?: string | null;
      lineNumber?: number | null;
      functionName?: string | null;
      columnNumber?: number | null;
    } | null>;
  } | null> | null;
  rage_clicks: Array<{ __typename?: 'RageClickEvent'; start_timestamp: any; end_timestamp: any; total_clicks: number }>;
  session_comments: Array<{
    __typename?: 'SessionComment';
    id: string;
    timestamp?: number | null;
    session_id: number;
    session_secure_id: string;
    created_at: any;
    updated_at: any;
    project_id: string;
    text: string;
    x_coordinate?: number | null;
    y_coordinate?: number | null;
    type: Types.SessionCommentType;
    metadata?: any | null;
    tags: Array<string | null>;
    author?: {
      __typename?: 'SanitizedAdmin';
      id: string;
      name?: string | null;
      email: string;
      photo_url?: string | null;
    } | null;
    attachments: Array<{
      __typename?: 'ExternalAttachment';
      id: string;
      integration_type: Types.IntegrationType;
      external_id: string;
      title?: string | null;
    } | null>;
  } | null>;
};

export type GetEventChunkUrlQueryVariables = Types.Exact<{
  secure_id: Types.Scalars['String']['input'];
  index: Types.Scalars['Int']['input'];
}>;

export type GetEventChunkUrlQuery = { __typename?: 'Query'; event_chunk_url: string };

export type GetEventChunksQueryVariables = Types.Exact<{
  secure_id: Types.Scalars['String']['input'];
}>;

export type GetEventChunksQuery = {
  __typename?: 'Query';
  event_chunks: Array<{ __typename?: 'EventChunk'; session_id: number; chunk_index: number; timestamp: any }>;
};

export type GetSessionQueryVariables = Types.Exact<{
  secure_id: Types.Scalars['String']['input'];
}>;

export type GetSessionQuery = {
  __typename?: 'Query';
  session?: {
    __typename?: 'Session';
    secure_id: string;
    ld_project_slug?: string | null;
    os_name: string;
    os_version: string;
    browser_name: string;
    browser_version: string;
    environment?: string | null;
    service_name?: string | null;
    app_version?: string | null;
    ip: string;
    city: string;
    state: string;
    country: string;
    postal: string;
    fingerprint?: number | null;
    created_at: any;
    payload_updated_at?: any | null;
    language: string;
    user_object?: any | null;
    user_properties?: string | null;
    identifier: string;
    identified: boolean;
    client_id: string;
    starred?: boolean | null;
    viewed?: boolean | null;
    enable_strict_privacy?: boolean | null;
    privacy_setting?: string | null;
    enable_recording_network_contents?: boolean | null;
    field_group?: string | null;
    object_storage_enabled?: boolean | null;
    payload_size?: any | null;
    processed?: boolean | null;
    excluded: boolean;
    excluded_reason?: Types.SessionExcludedReason | null;
    has_rage_clicks?: boolean | null;
    has_errors?: boolean | null;
    first_time?: boolean | null;
    within_billing_quota?: boolean | null;
    client_version?: string | null;
    firstload_version?: string | null;
    client_config?: string | null;
    is_public: boolean;
    event_counts?: string | null;
    direct_download_url?: string | null;
    resources_url?: string | null;
    web_socket_events_url?: string | null;
    timeline_indicators_url?: string | null;
    deviceMemory?: number | null;
    last_user_interaction_time: any;
    length?: number | null;
    active_length?: number | null;
    chunked?: boolean | null;
    fields?: Array<{ __typename?: 'Field'; name: string; value: string; type?: string | null } | null> | null;
    jira_issue_links?: Array<{
      __typename?: 'LinkedJiraIssue';
      id: string;
      issueKey: string;
      issueUrl: string;
      createdAt: any;
    }> | null;
  } | null;
};

export type GetWorkspaceAdminsByProjectIdQueryVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
}>;

export type GetWorkspaceAdminsByProjectIdQuery = {
  __typename?: 'Query';
  admins: Array<{
    __typename?: 'WorkspaceAdminRole';
    workspaceId: string;
    role: string;
    projectIds: Array<string>;
    admin: { __typename?: 'Admin'; id: string; name: string; email: string; photo_url?: string | null };
  }>;
};

export type GetWorkspaceAdminsQueryVariables = Types.Exact<{
  workspace_id: Types.Scalars['ID']['input'];
}>;

export type GetWorkspaceAdminsQuery = {
  __typename?: 'Query';
  admins: Array<{
    __typename?: 'WorkspaceAdminRole';
    workspaceId: string;
    role: string;
    projectIds: Array<string>;
    admin: { __typename?: 'Admin'; id: string; name: string; email: string; photo_url?: string | null };
  }>;
  workspace?: {
    __typename?: 'Workspace';
    id: string;
    name: string;
    allowed_auto_join_email_origins?: string | null;
  } | null;
  workspace_invite_links: {
    __typename?: 'WorkspaceInviteLink';
    id: string;
    invitee_email?: string | null;
    invitee_role: string;
    expiration_date: any;
    secret: string;
  };
};

export type GetSessionInsightQueryVariables = Types.Exact<{
  secure_id: Types.Scalars['String']['input'];
}>;

export type GetSessionInsightQuery = {
  __typename?: 'Query';
  session_insight?: { __typename?: 'SessionInsight'; id: string; insight: string } | null;
};

export type GetSessionExportsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
}>;

export type GetSessionExportsQuery = {
  __typename?: 'Query';
  session_exports: Array<{
    __typename?: 'SessionExportWithSession';
    created_at: any;
    type: string;
    url: string;
    error: string;
    secure_id: string;
    identifier: string;
    active_length?: number | null;
  }>;
};

export type GetSessionCommentsQueryVariables = Types.Exact<{
  session_secure_id: Types.Scalars['String']['input'];
}>;

export type GetSessionCommentsQuery = {
  __typename?: 'Query';
  session_comments: Array<{
    __typename?: 'SessionComment';
    id: string;
    timestamp?: number | null;
    text: string;
    author?: { __typename?: 'SanitizedAdmin'; email: string } | null;
  } | null>;
};

export type IsSessionPendingQueryVariables = Types.Exact<{
  session_secure_id: Types.Scalars['String']['input'];
}>;

export type IsSessionPendingQuery = { __typename?: 'Query'; isSessionPending?: boolean | null };

export type GetSessionIntervalsQueryVariables = Types.Exact<{
  session_secure_id: Types.Scalars['String']['input'];
}>;

export type GetSessionIntervalsQuery = {
  __typename?: 'Query';
  session_intervals: Array<{
    __typename?: 'SessionInterval';
    start_time: any;
    end_time: any;
    active: boolean;
    duration: number;
  }>;
};

export type GetTimelineIndicatorEventsQueryVariables = Types.Exact<{
  session_secure_id: Types.Scalars['String']['input'];
}>;

export type GetTimelineIndicatorEventsQuery = {
  __typename?: 'Query';
  timeline_indicator_events: Array<{
    __typename?: 'TimelineIndicatorEvent';
    timestamp: number;
    data?: any | null;
    type: number;
    sid: number;
  }>;
};

export type GetSessionChunkPreviewFramesQueryVariables = Types.Exact<{
  session_secure_id: Types.Scalars['String']['input'];
  timestamp_ms: Types.Scalars['Int']['input'];
}>;

export type GetSessionChunkPreviewFramesQuery = {
  __typename?: 'Query';
  sessionChunkPreviewFrames: {
    __typename?: 'SessionChunkPreviewFrames';
    chunk_index: number;
    chunk_start_ms: number;
    frame_interval_ms: number;
    is_complete: boolean;
    frames: Array<{ __typename?: 'ChunkPreviewFrame'; ts_ms: number; url: string }>;
  };
};

export type GetWebSocketEventsQueryVariables = Types.Exact<{
  session_secure_id: Types.Scalars['String']['input'];
}>;

export type GetWebSocketEventsQuery = { __typename?: 'Query'; websocket_events?: Array<any | null> | null };

export type GetSessionsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  count: Types.Scalars['Int']['input'];
  params: Types.QueryInput;
  sort_desc: Types.Scalars['Boolean']['input'];
  sort_field?: Types.InputMaybe<Types.Scalars['String']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  query_settings?: Types.InputMaybe<Types.QuerySettingsInput>;
}>;

export type GetSessionsQuery = {
  __typename?: 'Query';
  sessions: {
    __typename?: 'SessionResults';
    totalCount: any;
    totalLength: any;
    totalActiveLength: any;
    sessions: Array<{
      __typename?: 'Session';
      id: any;
      project_id: number;
      secure_id: string;
      client_id: string;
      fingerprint?: number | null;
      identifier: string;
      identified: boolean;
      os_name: string;
      os_version: string;
      browser_name: string;
      browser_version: string;
      ip: string;
      city: string;
      state: string;
      country: string;
      postal: string;
      created_at: any;
      language: string;
      length?: number | null;
      active_length?: number | null;
      enable_recording_network_contents?: boolean | null;
      viewed?: boolean | null;
      starred?: boolean | null;
      processed?: boolean | null;
      has_rage_clicks?: boolean | null;
      has_errors?: boolean | null;
      first_time?: boolean | null;
      user_properties?: string | null;
      event_counts?: string | null;
      last_user_interaction_time: any;
      is_public: boolean;
      excluded: boolean;
      email?: string | null;
      fields?: Array<{
        __typename?: 'Field';
        name: string;
        value: string;
        type?: string | null;
        id: any;
      } | null> | null;
    }>;
  };
};

export type GetEventSessionsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  count: Types.Scalars['Int']['input'];
  params: Types.QueryInput;
  sort_desc: Types.Scalars['Boolean']['input'];
  sort_field?: Types.InputMaybe<Types.Scalars['String']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetEventSessionsQuery = {
  __typename?: 'Query';
  event_sessions: {
    __typename?: 'SessionResults';
    totalCount: any;
    sessions: Array<{
      __typename?: 'Session';
      id: any;
      project_id: number;
      secure_id: string;
      client_id: string;
      fingerprint?: number | null;
      identifier: string;
      identified: boolean;
      os_name: string;
      os_version: string;
      browser_name: string;
      browser_version: string;
      ip: string;
      city: string;
      state: string;
      country: string;
      postal: string;
      created_at: any;
      language: string;
      length?: number | null;
      active_length?: number | null;
      enable_recording_network_contents?: boolean | null;
      viewed?: boolean | null;
      starred?: boolean | null;
      processed?: boolean | null;
      has_rage_clicks?: boolean | null;
      has_errors?: boolean | null;
      first_time?: boolean | null;
      user_properties?: string | null;
      event_counts?: string | null;
      last_user_interaction_time: any;
      is_public: boolean;
      excluded: boolean;
      email?: string | null;
      fields?: Array<{
        __typename?: 'Field';
        name: string;
        value: string;
        type?: string | null;
        id: any;
      } | null> | null;
    }>;
  };
};

export type GetSessionsHistogramQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  params: Types.QueryInput;
  histogram_options: Types.DateHistogramOptions;
}>;

export type GetSessionsHistogramQuery = {
  __typename?: 'Query';
  sessions_histogram: {
    __typename?: 'SessionsHistogram';
    bucket_times: Array<any>;
    sessions_without_errors: Array<any>;
    sessions_with_errors: Array<any>;
    total_sessions: Array<any>;
    inactive_lengths: Array<any>;
    active_lengths: Array<any>;
  };
};

export type GetSessionUsersReportsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  params: Types.QueryInput;
  timezone?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetSessionUsersReportsQuery = {
  __typename?: 'Query';
  session_users_report: Array<{
    __typename?: 'SessionsReportRow';
    key: string;
    email: string;
    first_session: any;
    last_session: any;
    num_sessions: any;
    num_days_visited: any;
    num_months_visited: any;
    avg_active_length_mins: number;
    max_active_length_mins: number;
    total_active_length_mins: number;
    avg_length_mins: number;
    max_length_mins: number;
    total_length_mins: number;
    location: string;
    daily_sessions: Array<{ __typename?: 'SessionsReportDay'; day: any; num_sessions: any }>;
  }>;
};

export type GetErrorGroupsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  count: Types.Scalars['Int']['input'];
  params: Types.QueryInput;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetErrorGroupsQuery = {
  __typename?: 'Query';
  error_groups: {
    __typename?: 'ErrorResults';
    totalCount: any;
    error_groups: Array<{
      __typename?: 'ErrorGroup';
      created_at: any;
      updated_at: any;
      id: any;
      secure_id: string;
      type: string;
      event: Array<string | null>;
      state: Types.ErrorState;
      first_occurrence?: any | null;
      last_occurrence?: any | null;
      snoozed_until?: any | null;
      environments?: string | null;
      error_frequency: Array<any>;
      is_public: boolean;
      project_id: number;
      structured_stack_trace: Array<{ __typename?: 'ErrorTrace'; fileName?: string | null } | null>;
      error_metrics: Array<{
        __typename?: 'ErrorDistributionItem';
        error_group_id: any;
        date: any;
        name: string;
        value: any;
      }>;
    }>;
  };
};

export type GetErrorGroupsForFlagVariationQueryVariables = Types.Exact<{
  ld_project_id: Types.Scalars['String']['input'];
  ld_environment_id: Types.Scalars['String']['input'];
  flag_key: Types.Scalars['String']['input'];
  flag_variation_value_json: Types.Scalars['String']['input'];
  count: Types.Scalars['Int']['input'];
  params: Types.QueryInput;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetErrorGroupsForFlagVariationQuery = {
  __typename?: 'Query';
  error_groups_for_flag_variation: {
    __typename?: 'ErrorResults';
    totalCount: any;
    error_groups: Array<{
      __typename?: 'ErrorGroup';
      created_at: any;
      updated_at: any;
      id: any;
      secure_id: string;
      type: string;
      event: Array<string | null>;
      state: Types.ErrorState;
      first_occurrence?: any | null;
      last_occurrence?: any | null;
      snoozed_until?: any | null;
      environments?: string | null;
      error_frequency: Array<any>;
      is_public: boolean;
      project_id: number;
      error_metrics: Array<{
        __typename?: 'ErrorDistributionItem';
        error_group_id: any;
        date: any;
        name: string;
        value: any;
      }>;
    }>;
  };
};

export type GetErrorsHistogramQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  params: Types.QueryInput;
  histogram_options: Types.DateHistogramOptions;
}>;

export type GetErrorsHistogramQuery = {
  __typename?: 'Query';
  errors_histogram: { __typename?: 'ErrorsHistogram'; bucket_times: Array<any>; error_objects: Array<any> };
};

export type GetProjectsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetProjectsQuery = {
  __typename?: 'Query';
  projects?: Array<{
    __typename?: 'Project';
    id: string;
    name: string;
    verbose_id: string;
    billing_email?: string | null;
    secret?: string | null;
    workspace_id: string;
    error_filters?: any | null;
    excluded_users?: any | null;
    error_json_paths?: any | null;
    filter_chrome_extension?: boolean | null;
    rage_click_window_seconds?: number | null;
    rage_click_radius_pixels?: number | null;
    rage_click_count?: number | null;
    platforms?: any | null;
    workspace?: { __typename?: 'Workspace'; id: string } | null;
  } | null> | null;
};

export type GetWorkspaceQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetWorkspaceQuery = {
  __typename?: 'Query';
  workspace?: {
    __typename?: 'Workspace';
    id: string;
    name: string;
    plan_tier: string;
    unlimited_members: boolean;
    projects: Array<{
      __typename?: 'Project';
      id: string;
      name: string;
      verbose_id: string;
      billing_email?: string | null;
      secret?: string | null;
      workspace_id: string;
      error_filters?: any | null;
      excluded_users?: any | null;
      error_json_paths?: any | null;
      filter_chrome_extension?: boolean | null;
      rage_click_window_seconds?: number | null;
      rage_click_radius_pixels?: number | null;
      rage_click_count?: number | null;
      platforms?: any | null;
      workspace?: { __typename?: 'Workspace'; id: string } | null;
    } | null>;
  } | null;
};

export type GetWorkspaceForInviteLinkQueryVariables = Types.Exact<{
  secret: Types.Scalars['String']['input'];
}>;

export type GetWorkspaceForInviteLinkQuery = {
  __typename?: 'Query';
  workspace_for_invite_link: {
    __typename?: 'WorkspaceForInviteLink';
    expiration_date?: any | null;
    existing_account: boolean;
    invitee_email?: string | null;
    secret: string;
    workspace_id: string;
    workspace_name: string;
    project_id: string;
  };
};

export type GetWorkspacesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetWorkspacesQuery = {
  __typename?: 'Query';
  workspaces?: Array<{
    __typename?: 'Workspace';
    id: string;
    name: string;
    retention_period: Types.RetentionPeriod;
    errors_retention_period: Types.RetentionPeriod;
    logs_retention_period: Types.RetentionPeriod;
    traces_retention_period: Types.RetentionPeriod;
    metrics_retention_period: Types.RetentionPeriod;
  } | null> | null;
  joinable_workspaces?: Array<{
    __typename?: 'Workspace';
    id: string;
    name: string;
    projects: Array<{
      __typename?: 'Project';
      id: string;
      name: string;
      verbose_id: string;
      billing_email?: string | null;
      secret?: string | null;
      workspace_id: string;
      error_filters?: any | null;
      excluded_users?: any | null;
      error_json_paths?: any | null;
      filter_chrome_extension?: boolean | null;
      rage_click_window_seconds?: number | null;
      rage_click_radius_pixels?: number | null;
      rage_click_count?: number | null;
      platforms?: any | null;
      workspace?: { __typename?: 'Workspace'; id: string } | null;
    } | null>;
  } | null> | null;
};

export type GetWorkspacesCountQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetWorkspacesCountQuery = { __typename?: 'Query'; workspaces_count: any };

export type GetProjectsAndWorkspacesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetProjectsAndWorkspacesQuery = {
  __typename?: 'Query';
  projects?: Array<{
    __typename?: 'Project';
    id: string;
    name: string;
    verbose_id: string;
    billing_email?: string | null;
    secret?: string | null;
    workspace_id: string;
    error_filters?: any | null;
    excluded_users?: any | null;
    error_json_paths?: any | null;
    filter_chrome_extension?: boolean | null;
    rage_click_window_seconds?: number | null;
    rage_click_radius_pixels?: number | null;
    rage_click_count?: number | null;
    platforms?: any | null;
    workspace?: { __typename?: 'Workspace'; id: string } | null;
  } | null> | null;
  workspaces?: Array<{ __typename?: 'Workspace'; id: string; name: string } | null> | null;
};

export type GetProjectOrWorkspaceQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  workspace_id: Types.Scalars['ID']['input'];
  is_workspace: Types.Scalars['Boolean']['input'];
}>;

export type GetProjectOrWorkspaceQuery = {
  __typename?: 'Query';
  project?: {
    __typename?: 'Project';
    id: string;
    name: string;
    verbose_id: string;
    billing_email?: string | null;
    secret?: string | null;
    workspace_id: string;
    error_filters?: any | null;
    excluded_users?: any | null;
    error_json_paths?: any | null;
    filter_chrome_extension?: boolean | null;
    rage_click_window_seconds?: number | null;
    rage_click_radius_pixels?: number | null;
    rage_click_count?: number | null;
    platforms?: any | null;
    workspace?: {
      __typename?: 'Workspace';
      id: string;
      name: string;
      retention_period: Types.RetentionPeriod;
      errors_retention_period: Types.RetentionPeriod;
      metrics_retention_period: Types.RetentionPeriod;
      projects: Array<{
        __typename?: 'Project';
        id: string;
        name: string;
        verbose_id: string;
        billing_email?: string | null;
        secret?: string | null;
        workspace_id: string;
        error_filters?: any | null;
        excluded_users?: any | null;
        error_json_paths?: any | null;
        filter_chrome_extension?: boolean | null;
        rage_click_window_seconds?: number | null;
        rage_click_radius_pixels?: number | null;
        rage_click_count?: number | null;
        platforms?: any | null;
        workspace?: { __typename?: 'Workspace'; id: string } | null;
      } | null>;
    } | null;
  } | null;
  workspace?: {
    __typename?: 'Workspace';
    id: string;
    name: string;
    cloudflare_proxy?: string | null;
    retention_period: Types.RetentionPeriod;
    errors_retention_period: Types.RetentionPeriod;
    metrics_retention_period: Types.RetentionPeriod;
    projects: Array<{
      __typename?: 'Project';
      id: string;
      name: string;
      verbose_id: string;
      billing_email?: string | null;
      secret?: string | null;
      workspace_id: string;
      error_filters?: any | null;
      excluded_users?: any | null;
      error_json_paths?: any | null;
      filter_chrome_extension?: boolean | null;
      rage_click_window_seconds?: number | null;
      rage_click_radius_pixels?: number | null;
      rage_click_count?: number | null;
      platforms?: any | null;
      workspace?: { __typename?: 'Workspace'; id: string } | null;
    } | null>;
  } | null;
};

export type GetDropdownOptionsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetDropdownOptionsQuery = {
  __typename?: 'Query';
  projects?: Array<{
    __typename?: 'Project';
    id: string;
    name: string;
    verbose_id: string;
    billing_email?: string | null;
    secret?: string | null;
    workspace_id: string;
    error_filters?: any | null;
    excluded_users?: any | null;
    error_json_paths?: any | null;
    filter_chrome_extension?: boolean | null;
    rage_click_window_seconds?: number | null;
    rage_click_radius_pixels?: number | null;
    rage_click_count?: number | null;
    platforms?: any | null;
    workspace?: { __typename?: 'Workspace'; id: string } | null;
  } | null> | null;
  workspaces?: Array<{
    __typename?: 'Workspace';
    id: string;
    name: string;
    cloudflare_proxy?: string | null;
    retention_period: Types.RetentionPeriod;
    errors_retention_period: Types.RetentionPeriod;
    projects: Array<{ __typename?: 'Project'; id: string } | null>;
  } | null> | null;
  joinable_workspaces?: Array<{
    __typename?: 'Workspace';
    id: string;
    name: string;
    projects: Array<{
      __typename?: 'Project';
      id: string;
      name: string;
      verbose_id: string;
      billing_email?: string | null;
      secret?: string | null;
      workspace_id: string;
      error_filters?: any | null;
      excluded_users?: any | null;
      error_json_paths?: any | null;
      filter_chrome_extension?: boolean | null;
      rage_click_window_seconds?: number | null;
      rage_click_radius_pixels?: number | null;
      rage_click_count?: number | null;
      platforms?: any | null;
      workspace?: { __typename?: 'Workspace'; id: string } | null;
    } | null>;
  } | null> | null;
};

export type GetAdminQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetAdminQuery = {
  __typename?: 'Query';
  admin?: {
    __typename?: 'Admin';
    id: string;
    uid: string;
    name: string;
    email: string;
    phone?: string | null;
    photo_url?: string | null;
    slack_im_channel_id?: string | null;
    email_verified?: boolean | null;
    user_defined_role?: string | null;
    about_you_details_filled?: boolean | null;
  } | null;
};

export type GetAdminRoleQueryVariables = Types.Exact<{
  workspace_id: Types.Scalars['ID']['input'];
}>;

export type GetAdminRoleQuery = {
  __typename?: 'Query';
  admin_role?: {
    __typename?: 'WorkspaceAdminRole';
    workspaceId: string;
    role: string;
    projectIds: Array<string>;
    admin: {
      __typename?: 'Admin';
      id: string;
      uid: string;
      name: string;
      email: string;
      phone?: string | null;
      photo_url?: string | null;
      slack_im_channel_id?: string | null;
      email_verified?: boolean | null;
      user_defined_role?: string | null;
      about_you_details_filled?: boolean | null;
    };
  } | null;
};

export type GetAdminRoleByProjectQueryVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
}>;

export type GetAdminRoleByProjectQuery = {
  __typename?: 'Query';
  admin_role_by_project?: {
    __typename?: 'WorkspaceAdminRole';
    workspaceId: string;
    role: string;
    projectIds: Array<string>;
    admin: {
      __typename?: 'Admin';
      id: string;
      uid: string;
      name: string;
      email: string;
      phone?: string | null;
      photo_url?: string | null;
      slack_im_channel_id?: string | null;
      email_verified?: boolean | null;
      user_defined_role?: string | null;
      about_you_details_filled?: boolean | null;
    };
  } | null;
};

export type GetAdminAboutYouQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetAdminAboutYouQuery = {
  __typename?: 'Query';
  admin?: {
    __typename?: 'Admin';
    id: string;
    name: string;
    user_defined_role?: string | null;
    referral?: string | null;
  } | null;
};

export type GetProjectQueryVariables = Types.Exact<{
  id: Types.Scalars['StringID']['input'];
}>;

export type GetProjectQuery = {
  __typename?: 'Query';
  project?: {
    __typename?: 'Project';
    id: string;
    name: string;
    verbose_id: string;
    billing_email?: string | null;
    secret?: string | null;
    workspace_id: string;
    error_filters?: any | null;
    excluded_users?: any | null;
    error_json_paths?: any | null;
    filter_chrome_extension?: boolean | null;
    rage_click_window_seconds?: number | null;
    rage_click_radius_pixels?: number | null;
    rage_click_count?: number | null;
    platforms?: any | null;
    workspace?: {
      __typename?: 'Workspace';
      id: string;
      slack_webhook_channel?: string | null;
      retention_period: Types.RetentionPeriod;
      errors_retention_period: Types.RetentionPeriod;
      logs_retention_period: Types.RetentionPeriod;
      traces_retention_period: Types.RetentionPeriod;
      metrics_retention_period: Types.RetentionPeriod;
    } | null;
  } | null;
};

export type GetBillingDetailsForProjectQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
}>;

export type GetBillingDetailsForProjectQuery = {
  __typename?: 'Query';
  billingDetailsForProject?: {
    __typename?: 'BillingDetails';
    meter: any;
    membersMeter: any;
    errorsMeter: any;
    logsMeter: any;
    tracesMeter: any;
    metricsMeter: any;
    sessionsBillingLimit?: any | null;
    errorsBillingLimit?: any | null;
    logsBillingLimit?: any | null;
    tracesBillingLimit?: any | null;
    metricsBillingLimit?: any | null;
    plan: {
      __typename?: 'Plan';
      type: Types.PlanType;
      interval: Types.SubscriptionInterval;
      membersLimit?: any | null;
      sessionsLimit: any;
      errorsLimit: any;
      logsLimit: any;
      tracesLimit: any;
      metricsLimit: any;
      sessionsRate: number;
      errorsRate: number;
      logsRate: number;
      tracesRate: number;
      metricsRate: number;
      aws_mp_subscription?: {
        __typename?: 'AWSMarketplaceSubscription';
        customer_identifier: string;
        customer_aws_account_id: string;
        product_code: string;
      } | null;
    };
  } | null;
  project?: {
    __typename?: 'Project';
    workspace?: {
      __typename?: 'Workspace';
      id: string;
      billing_period_end?: any | null;
      next_invoice_date?: any | null;
      allow_meter_overage: boolean;
    } | null;
  } | null;
};

export type GetWorkspaceUsageHistoryQueryVariables = Types.Exact<{
  workspace_id: Types.Scalars['ID']['input'];
  product_type: Types.ProductType;
  date_range?: Types.InputMaybe<Types.DateRangeRequiredInput>;
}>;

export type GetWorkspaceUsageHistoryQuery = {
  __typename?: 'Query';
  usageHistory: {
    __typename?: 'UsageHistory';
    usage: {
      __typename?: 'MetricsBuckets';
      bucket_count: any;
      sample_factor: number;
      buckets: Array<{
        __typename?: 'MetricBucket';
        bucket_id: any;
        bucket_min?: number | null;
        bucket_max?: number | null;
        column: string;
        group: Array<string>;
        metric_type: Types.MetricAggregator;
        metric_value?: number | null;
      }>;
    };
  };
};

export type GetBillingDetailsQueryVariables = Types.Exact<{
  workspace_id: Types.Scalars['ID']['input'];
}>;

export type GetBillingDetailsQuery = {
  __typename?: 'Query';
  billingDetails: {
    __typename?: 'BillingDetails';
    meter: any;
    membersMeter: any;
    errorsMeter: any;
    logsMeter: any;
    tracesMeter: any;
    metricsMeter: any;
    sessionsBillingLimit?: any | null;
    errorsBillingLimit?: any | null;
    logsBillingLimit?: any | null;
    tracesBillingLimit?: any | null;
    metricsBillingLimit?: any | null;
    sessionsDailyAverage: number;
    errorsDailyAverage: number;
    logsDailyAverage: number;
    tracesDailyAverage: number;
    metricsDailyAverage: number;
    plan: {
      __typename?: 'Plan';
      type: Types.PlanType;
      interval: Types.SubscriptionInterval;
      membersLimit?: any | null;
      sessionsLimit: any;
      errorsLimit: any;
      logsLimit: any;
      tracesLimit: any;
      metricsLimit: any;
      sessionsRate: number;
      errorsRate: number;
      logsRate: number;
      tracesRate: number;
      metricsRate: number;
      enableBillingLimits: boolean;
      aws_mp_subscription?: {
        __typename?: 'AWSMarketplaceSubscription';
        customer_identifier: string;
        customer_aws_account_id: string;
        product_code: string;
      } | null;
    };
  };
  subscription_details?: {
    __typename?: 'SubscriptionDetails';
    baseAmount: any;
    billingIssue: boolean;
    billingIngestBlocked: boolean;
    discount?: {
      __typename?: 'SubscriptionDiscount';
      name: string;
      amount: any;
      percent: number;
      until?: any | null;
    } | null;
    lastInvoice?: {
      __typename?: 'Invoice';
      amountDue?: any | null;
      amountPaid?: any | null;
      attemptCount?: any | null;
      date?: any | null;
      url?: string | null;
      status?: string | null;
    } | null;
  } | null;
  workspace?: {
    __typename?: 'Workspace';
    id: string;
    billing_period_end?: any | null;
    next_invoice_date?: any | null;
    allow_meter_overage: boolean;
    retention_period: Types.RetentionPeriod;
    errors_retention_period: Types.RetentionPeriod;
    logs_retention_period: Types.RetentionPeriod;
    traces_retention_period: Types.RetentionPeriod;
    metrics_retention_period: Types.RetentionPeriod;
    sessions_max_cents?: number | null;
    errors_max_cents?: number | null;
    logs_max_cents?: number | null;
    traces_max_cents?: number | null;
    metrics_max_cents?: number | null;
  } | null;
};

export type GetSubscriptionDetailsQueryVariables = Types.Exact<{
  workspace_id: Types.Scalars['ID']['input'];
}>;

export type GetSubscriptionDetailsQuery = {
  __typename?: 'Query';
  subscription_details?: {
    __typename?: 'SubscriptionDetails';
    baseAmount: any;
    billingIssue: boolean;
    billingIngestBlocked: boolean;
    discount?: {
      __typename?: 'SubscriptionDiscount';
      name: string;
      amount: any;
      percent: number;
      until?: any | null;
    } | null;
    lastInvoice?: {
      __typename?: 'Invoice';
      amountDue?: any | null;
      amountPaid?: any | null;
      attemptCount?: any | null;
      date?: any | null;
      url?: string | null;
      status?: string | null;
    } | null;
  } | null;
};

export type GetErrorGroupQueryVariables = Types.Exact<{
  secure_id: Types.Scalars['String']['input'];
  use_clickhouse?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type GetErrorGroupQuery = {
  __typename?: 'Query';
  error_group?: {
    __typename?: 'ErrorGroup';
    created_at: any;
    updated_at: any;
    id: any;
    secure_id: string;
    type: string;
    project_id: number;
    event: Array<string | null>;
    state: Types.ErrorState;
    snoozed_until?: any | null;
    mapped_stack_trace?: string | null;
    stack_trace?: string | null;
    error_frequency: Array<any>;
    is_public: boolean;
    last_occurrence?: any | null;
    first_occurrence?: any | null;
    serviceName?: string | null;
    structured_stack_trace: Array<{
      __typename?: 'ErrorTrace';
      fileName?: string | null;
      lineNumber?: number | null;
      functionName?: string | null;
      columnNumber?: number | null;
      lineContent?: string | null;
      linesBefore?: string | null;
      linesAfter?: string | null;
      error?: string | null;
    } | null>;
    error_metrics: Array<{
      __typename?: 'ErrorDistributionItem';
      error_group_id: any;
      date: any;
      name: string;
      value: any;
    }>;
    jira_issue_links?: Array<{
      __typename?: 'LinkedJiraIssue';
      id: string;
      issueKey: string;
      issueUrl: string;
      createdAt: any;
    }> | null;
  } | null;
};

export type GetErrorObjectForLogQueryVariables = Types.Exact<{
  log_cursor: Types.Scalars['String']['input'];
}>;

export type GetErrorObjectForLogQuery = {
  __typename?: 'Query';
  error_object_for_log?: {
    __typename?: 'ErrorObject';
    id: any;
    error_group_secure_id: string;
    project_id: number;
  } | null;
};

export type ErrorObjectFragment = {
  __typename?: 'ErrorObject';
  id: any;
  created_at: any;
  project_id: number;
  session_id?: number | null;
  trace_id?: string | null;
  span_id?: string | null;
  log_cursor?: string | null;
  error_group_id: number;
  error_group_secure_id: string;
  event: Array<string | null>;
  type: string;
  url: string;
  source?: string | null;
  lineNumber?: number | null;
  columnNumber?: number | null;
  stack_trace: string;
  timestamp: any;
  payload?: string | null;
  request_id?: string | null;
  os?: string | null;
  browser?: string | null;
  environment?: string | null;
  serviceVersion?: string | null;
  serviceName?: string | null;
  attributes?: any | null;
  session?: {
    __typename?: 'Session';
    identifier: string;
    fingerprint?: number | null;
    secure_id: string;
    city: string;
    state: string;
    country: string;
    user_properties?: string | null;
    processed?: boolean | null;
    excluded: boolean;
    excluded_reason?: Types.SessionExcludedReason | null;
    session_feedback?: Array<{
      __typename?: 'SessionComment';
      id: string;
      timestamp?: number | null;
      created_at: any;
      updated_at: any;
      project_id: string;
      text: string;
    }> | null;
  } | null;
  structured_stack_trace: Array<{
    __typename?: 'ErrorTrace';
    fileName?: string | null;
    lineNumber?: number | null;
    functionName?: string | null;
    columnNumber?: number | null;
    lineContent?: string | null;
    linesBefore?: string | null;
    linesAfter?: string | null;
    error?: string | null;
    enhancementSource?: Types.EnhancementSource | null;
    enhancementVersion?: string | null;
    externalLink?: string | null;
    sourceMappingErrorMetadata?: {
      __typename?: 'SourceMappingError';
      errorCode?: Types.SourceMappingErrorCode | null;
      stackTraceFileURL?: string | null;
      sourcemapFetchStrategy?: string | null;
      sourceMapURL?: string | null;
      minifiedFetchStrategy?: string | null;
      actualMinifiedFetchedPath?: string | null;
      minifiedLineNumber?: number | null;
      minifiedColumnNumber?: number | null;
      actualSourcemapFetchedPath?: string | null;
      sourcemapFileSize?: number | null;
      minifiedFileSize?: number | null;
      mappedLineNumber?: number | null;
      mappedColumnNumber?: number | null;
    } | null;
  } | null>;
};

export type ProjectFragment = {
  __typename?: 'Project';
  id: string;
  name: string;
  verbose_id: string;
  billing_email?: string | null;
  secret?: string | null;
  workspace_id: string;
  error_filters?: any | null;
  excluded_users?: any | null;
  error_json_paths?: any | null;
  filter_chrome_extension?: boolean | null;
  rage_click_window_seconds?: number | null;
  rage_click_radius_pixels?: number | null;
  rage_click_count?: number | null;
  platforms?: any | null;
  workspace?: { __typename?: 'Workspace'; id: string } | null;
};

export type GetErrorObjectQueryVariables = Types.Exact<{
  id: Types.Scalars['Int64ID']['input'];
}>;

export type GetErrorObjectQuery = {
  __typename?: 'Query';
  error_object?: {
    __typename?: 'ErrorObject';
    id: any;
    created_at: any;
    project_id: number;
    session_id?: number | null;
    trace_id?: string | null;
    span_id?: string | null;
    log_cursor?: string | null;
    error_group_id: number;
    error_group_secure_id: string;
    event: Array<string | null>;
    type: string;
    url: string;
    source?: string | null;
    lineNumber?: number | null;
    columnNumber?: number | null;
    stack_trace: string;
    timestamp: any;
    payload?: string | null;
    request_id?: string | null;
    os?: string | null;
    browser?: string | null;
    environment?: string | null;
    serviceVersion?: string | null;
    serviceName?: string | null;
    attributes?: any | null;
    session?: {
      __typename?: 'Session';
      identifier: string;
      fingerprint?: number | null;
      secure_id: string;
      city: string;
      state: string;
      country: string;
      user_properties?: string | null;
      processed?: boolean | null;
      excluded: boolean;
      excluded_reason?: Types.SessionExcludedReason | null;
      session_feedback?: Array<{
        __typename?: 'SessionComment';
        id: string;
        timestamp?: number | null;
        created_at: any;
        updated_at: any;
        project_id: string;
        text: string;
      }> | null;
    } | null;
    structured_stack_trace: Array<{
      __typename?: 'ErrorTrace';
      fileName?: string | null;
      lineNumber?: number | null;
      functionName?: string | null;
      columnNumber?: number | null;
      lineContent?: string | null;
      linesBefore?: string | null;
      linesAfter?: string | null;
      error?: string | null;
      enhancementSource?: Types.EnhancementSource | null;
      enhancementVersion?: string | null;
      externalLink?: string | null;
      sourceMappingErrorMetadata?: {
        __typename?: 'SourceMappingError';
        errorCode?: Types.SourceMappingErrorCode | null;
        stackTraceFileURL?: string | null;
        sourcemapFetchStrategy?: string | null;
        sourceMapURL?: string | null;
        minifiedFetchStrategy?: string | null;
        actualMinifiedFetchedPath?: string | null;
        minifiedLineNumber?: number | null;
        minifiedColumnNumber?: number | null;
        actualSourcemapFetchedPath?: string | null;
        sourcemapFileSize?: number | null;
        minifiedFileSize?: number | null;
        mappedLineNumber?: number | null;
        mappedColumnNumber?: number | null;
      } | null;
    } | null>;
  } | null;
};

export type GetErrorInstanceQueryVariables = Types.Exact<{
  error_group_secure_id: Types.Scalars['String']['input'];
  error_object_id?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  params?: Types.InputMaybe<Types.QueryInput>;
}>;

export type GetErrorInstanceQuery = {
  __typename?: 'Query';
  error_instance?: {
    __typename?: 'ErrorInstance';
    next_id?: string | null;
    previous_id?: string | null;
    error_object: {
      __typename?: 'ErrorObject';
      id: any;
      created_at: any;
      project_id: number;
      session_id?: number | null;
      trace_id?: string | null;
      span_id?: string | null;
      log_cursor?: string | null;
      error_group_id: number;
      error_group_secure_id: string;
      event: Array<string | null>;
      type: string;
      url: string;
      source?: string | null;
      lineNumber?: number | null;
      columnNumber?: number | null;
      stack_trace: string;
      timestamp: any;
      payload?: string | null;
      request_id?: string | null;
      os?: string | null;
      browser?: string | null;
      environment?: string | null;
      serviceVersion?: string | null;
      serviceName?: string | null;
      attributes?: any | null;
      session?: {
        __typename?: 'Session';
        identifier: string;
        fingerprint?: number | null;
        secure_id: string;
        city: string;
        state: string;
        country: string;
        user_properties?: string | null;
        processed?: boolean | null;
        excluded: boolean;
        excluded_reason?: Types.SessionExcludedReason | null;
        session_feedback?: Array<{
          __typename?: 'SessionComment';
          id: string;
          timestamp?: number | null;
          created_at: any;
          updated_at: any;
          project_id: string;
          text: string;
        }> | null;
      } | null;
      structured_stack_trace: Array<{
        __typename?: 'ErrorTrace';
        fileName?: string | null;
        lineNumber?: number | null;
        functionName?: string | null;
        columnNumber?: number | null;
        lineContent?: string | null;
        linesBefore?: string | null;
        linesAfter?: string | null;
        error?: string | null;
        enhancementSource?: Types.EnhancementSource | null;
        enhancementVersion?: string | null;
        externalLink?: string | null;
        sourceMappingErrorMetadata?: {
          __typename?: 'SourceMappingError';
          errorCode?: Types.SourceMappingErrorCode | null;
          stackTraceFileURL?: string | null;
          sourcemapFetchStrategy?: string | null;
          sourceMapURL?: string | null;
          minifiedFetchStrategy?: string | null;
          actualMinifiedFetchedPath?: string | null;
          minifiedLineNumber?: number | null;
          minifiedColumnNumber?: number | null;
          actualSourcemapFetchedPath?: string | null;
          sourcemapFileSize?: number | null;
          minifiedFileSize?: number | null;
          mappedLineNumber?: number | null;
          mappedColumnNumber?: number | null;
        } | null;
      } | null>;
    };
  } | null;
};

export type GetResourcesQueryVariables = Types.Exact<{
  session_secure_id: Types.Scalars['String']['input'];
}>;

export type GetResourcesQuery = { __typename?: 'Query'; resources?: Array<any | null> | null };

export type GetProjectSuggestionQueryVariables = Types.Exact<{
  query: Types.Scalars['String']['input'];
}>;

export type GetProjectSuggestionQuery = {
  __typename?: 'Query';
  projectSuggestion: Array<{ __typename?: 'Project'; id: string; name: string; workspace_id: string } | null>;
};

export type GetSavedSegmentsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  entity_type: Types.SavedSegmentEntityType;
}>;

export type GetSavedSegmentsQuery = {
  __typename?: 'Query';
  saved_segments?: Array<{
    __typename?: 'SavedSegment';
    id: string;
    name: string;
    params: {
      __typename?: 'SearchParams';
      bucket_by_key?: string | null;
      bucket_count?: number | null;
      bucket_interval?: number | null;
      graph_type?: string | null;
      group_by_keys?: any | null;
      limit?: number | null;
      limit_function_type?: Types.MetricAggregator | null;
      limit_metric?: string | null;
      query?: string | null;
      expressions?: Array<{
        __typename?: 'MetricExpression';
        aggregator: Types.MetricAggregator;
        column: string;
      }> | null;
    };
  } | null> | null;
};

export type GetClientIntegrationQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
}>;

export type GetClientIntegrationQuery = {
  __typename?: 'Query';
  clientIntegration: {
    __typename?: 'IntegrationStatus';
    integrated: boolean;
    resourceType: string;
    createdAt?: any | null;
  };
};

export type GetServerIntegrationQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
}>;

export type GetServerIntegrationQuery = {
  __typename?: 'Query';
  serverIntegration: {
    __typename?: 'IntegrationStatus';
    integrated: boolean;
    resourceType: string;
    createdAt?: any | null;
  };
};

export type GetLogsIntegrationQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
}>;

export type GetLogsIntegrationQuery = {
  __typename?: 'Query';
  logsIntegration: {
    __typename?: 'IntegrationStatus';
    integrated: boolean;
    resourceType: string;
    createdAt?: any | null;
  };
};

export type GetTracesIntegrationQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
}>;

export type GetTracesIntegrationQuery = {
  __typename?: 'Query';
  tracesIntegration: {
    __typename?: 'IntegrationStatus';
    integrated: boolean;
    resourceType: string;
    createdAt?: any | null;
  };
};

export type GetMetricsIntegrationQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
}>;

export type GetMetricsIntegrationQuery = {
  __typename?: 'Query';
  metricsIntegration: {
    __typename?: 'IntegrationStatus';
    integrated: boolean;
    resourceType: string;
    createdAt?: any | null;
  };
};

export type GetKeyPerformanceIndicatorsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
  lookback_days: Types.Scalars['Float']['input'];
}>;

export type GetKeyPerformanceIndicatorsQuery = {
  __typename?: 'Query';
  unprocessedSessionsCount?: any | null;
  liveUsersCount?: any | null;
  newUsersCount?: { __typename?: 'NewUsersCount'; count: any } | null;
  averageSessionLength?: { __typename?: 'AverageSessionLength'; length: number } | null;
  userFingerprintCount?: { __typename?: 'UserFingerprintCount'; count: any } | null;
};

export type GetReferrersCountQueryVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
  lookback_days: Types.Scalars['Float']['input'];
}>;

export type GetReferrersCountQuery = {
  __typename?: 'Query';
  referrers: Array<{ __typename?: 'ReferrerTablePayload'; host: string; count: number; percent: number } | null>;
};

export type GetNewUsersCountQueryVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
  lookback_days: Types.Scalars['Float']['input'];
}>;

export type GetNewUsersCountQuery = {
  __typename?: 'Query';
  newUsersCount?: { __typename?: 'NewUsersCount'; count: any } | null;
};

export type GetAverageSessionLengthQueryVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
  lookback_days: Types.Scalars['Float']['input'];
}>;

export type GetAverageSessionLengthQuery = {
  __typename?: 'Query';
  averageSessionLength?: { __typename?: 'AverageSessionLength'; length: number } | null;
};

export type GetTopUsersQueryVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
  lookback_days: Types.Scalars['Float']['input'];
}>;

export type GetTopUsersQuery = {
  __typename?: 'Query';
  topUsers: Array<{
    __typename?: 'TopUsersPayload';
    identifier: string;
    total_active_time: number;
    active_time_percentage: number;
    id: string;
    user_properties: string;
  } | null>;
};

export type GetDailySessionsCountQueryVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
  date_range: Types.DateRangeInput;
}>;

export type GetDailySessionsCountQuery = {
  __typename?: 'Query';
  dailySessionsCount: Array<{ __typename?: 'DailySessionCount'; date: any; count: any } | null>;
};

export type GetDailyErrorsCountQueryVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
  date_range: Types.DateRangeInput;
}>;

export type GetDailyErrorsCountQuery = {
  __typename?: 'Query';
  dailyErrorsCount: Array<{ __typename?: 'DailyErrorCount'; date: any; count: any } | null>;
};

export type GetRageClicksForProjectQueryVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
  lookback_days: Types.Scalars['Float']['input'];
}>;

export type GetRageClicksForProjectQuery = {
  __typename?: 'Query';
  rageClicksForProject: Array<{
    __typename?: 'RageClickEventForProject';
    identifier: string;
    session_secure_id: string;
    total_clicks: number;
    user_properties: string;
  }>;
};

export type GetDailyErrorFrequencyQueryVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
  error_group_secure_id: Types.Scalars['String']['input'];
  date_offset: Types.Scalars['Int']['input'];
}>;

export type GetDailyErrorFrequencyQuery = { __typename?: 'Query'; dailyErrorFrequency: Array<any> };

export type GetSlackChannelSuggestionQueryVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
}>;

export type GetSlackChannelSuggestionQuery = {
  __typename?: 'Query';
  slack_channel_suggestion: Array<{
    __typename?: 'SanitizedSlackChannel';
    webhook_channel?: string | null;
    webhook_channel_id?: string | null;
  }>;
};

export type GetWorkspaceIsIntegratedWithSlackQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
}>;

export type GetWorkspaceIsIntegratedWithSlackQuery = { __typename?: 'Query'; is_integrated_with_slack: boolean };

export type GetWorkspaceIsIntegratedWithCloudflareQueryVariables = Types.Exact<{
  workspace_id: Types.Scalars['ID']['input'];
}>;

export type GetWorkspaceIsIntegratedWithCloudflareQuery = {
  __typename?: 'Query';
  is_integrated_with_cloudflare: boolean;
};

export type GetJiraIntegrationSettingsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
}>;

export type GetJiraIntegrationSettingsQuery = {
  __typename?: 'Query';
  jira_projects?: Array<{
    __typename?: 'JiraProject';
    id: string;
    name: string;
    key: string;
    issueTypes?: Array<{ __typename?: 'JiraIssueType'; id: string; name: string; description: string } | null> | null;
  }> | null;
};

export type GetGitHubIntegrationSettingsQueryVariables = Types.Exact<{
  workspace_id: Types.Scalars['ID']['input'];
}>;

export type GetGitHubIntegrationSettingsQuery = {
  __typename?: 'Query';
  is_integrated: boolean;
  github_repos?: Array<{
    __typename?: 'GitHubRepo';
    repo_id: string;
    name: string;
    key: string;
    is_public: boolean;
  }> | null;
};

export type GetVegaIntegrationStatusQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
}>;

export type GetVegaIntegrationStatusQuery = {
  __typename?: 'Query';
  vega_integration_status: {
    __typename?: 'VegaIntegrationStatus';
    installationId: string;
    userTokenValid: boolean;
    authLink: string;
    repositories: Array<{ __typename?: 'GitHubRepo'; repo_id: string; name: string; key: string; is_public: boolean }>;
  };
};

export type GetGitlabIntegrationSettingsQueryVariables = Types.Exact<{
  workspace_id: Types.Scalars['ID']['input'];
}>;

export type GetGitlabIntegrationSettingsQuery = {
  __typename?: 'Query';
  is_integrated: boolean;
  gitlab_projects?: Array<{ __typename?: 'GitlabProject'; name: string; id: number; nameWithNameSpace: string }> | null;
};

export type GetGitHubIssueLabelsQueryVariables = Types.Exact<{
  workspace_id: Types.Scalars['ID']['input'];
  repository: Types.Scalars['String']['input'];
}>;

export type GetGitHubIssueLabelsQuery = { __typename?: 'Query'; github_issue_labels: Array<string> };

export type GetProjectIntegratedWithQueryVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
  integration_type: Types.IntegrationType;
}>;

export type GetProjectIntegratedWithQuery = { __typename?: 'Query'; is_project_integrated_with: boolean };

export type GetIdentifierSuggestionsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  query: Types.Scalars['String']['input'];
}>;

export type GetIdentifierSuggestionsQuery = { __typename?: 'Query'; identifier_suggestion: Array<string> };

export type GetServiceAlertsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
}>;

export type GetServiceAlertsQuery = {
  __typename?: 'Query';
  alerts: Array<{
    __typename?: 'Alert';
    id: string;
    name: string;
    product_type: Types.ProductType;
    disabled: boolean;
    query?: string | null;
  } | null>;
};

export type GetAlertsPagePayloadQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
}>;

export type GetAlertsPagePayloadQuery = {
  __typename?: 'Query';
  alerts: Array<{
    __typename?: 'Alert';
    id: string;
    updated_at: any;
    name: string;
    product_type: Types.ProductType;
    disabled: boolean;
    high_cardinality: boolean;
    sql?: string | null;
    destinations: Array<{
      __typename?: 'AlertDestination';
      id: string;
      destination_type: Types.AlertDestinationType;
      type_id: string;
      type_name: string;
    } | null>;
  } | null>;
};

export type GetAlertQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetAlertQuery = {
  __typename?: 'Query';
  alert: {
    __typename?: 'Alert';
    id: string;
    project_id: string;
    updated_at: any;
    name: string;
    message_content?: string | null;
    product_type: Types.ProductType;
    function_type: Types.MetricAggregator;
    population_function_type?: Types.MetricAggregator | null;
    population_query?: string | null;
    population_window?: number | null;
    function_column?: string | null;
    query?: string | null;
    group_by_key?: string | null;
    group_by_keys?: Array<string> | null;
    disabled: boolean;
    high_cardinality: boolean;
    last_admin_to_edit_id?: string | null;
    last_admin_to_edit_uid?: string | null;
    threshold_value?: number | null;
    threshold_window?: number | null;
    threshold_cooldown?: number | null;
    threshold_type?: Types.ThresholdType | null;
    threshold_condition?: Types.ThresholdCondition | null;
    sql?: string | null;
    auto_investigation_enabled: boolean;
    investigation_conversation_id?: string | null;
    investigation_started_at?: any | null;
    investigation_cooldown?: number | null;
    permission_mode?: string | null;
    investigation_repositories?: any | null;
    investigation_prompt?: string | null;
    evaluation_delay_seconds?: number | null;
    hide_graph: boolean;
    warn_threshold_value?: number | null;
    no_data_behavior: Types.NoDataBehavior;
    send_resolved_alert: boolean;
    tags?: Record<string, string> | null;
    destinations: Array<{
      __typename?: 'AlertDestination';
      id: string;
      destination_type: Types.AlertDestinationType;
      type_id: string;
      type_name: string;
    } | null>;
  };
};

export type GetAlertingAlertStateChangesQueryVariables = Types.Exact<{
  alert_id: Types.Scalars['ID']['input'];
  start_date: Types.Scalars['Timestamp']['input'];
  end_date: Types.Scalars['Timestamp']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetAlertingAlertStateChangesQuery = {
  __typename?: 'Query';
  alerting_alert_state_changes: {
    __typename?: 'AlertStateChangeResults';
    totalCount: any;
    alertStateChanges: Array<{
      __typename?: 'AlertStateChange';
      timestamp: any;
      state: Types.AlertState;
      groupByKey: string;
      investigationConversationId?: string | null;
    } | null>;
  };
};

export type GetLastAlertStateChangesQueryVariables = Types.Exact<{
  alert_id: Types.Scalars['ID']['input'];
}>;

export type GetLastAlertStateChangesQuery = {
  __typename?: 'Query';
  last_alert_state_changes: Array<{
    __typename?: 'AlertStateChange';
    timestamp: any;
    state: Types.AlertState;
    groupByKey: string;
  } | null>;
};

export type GetLastAlertingStateChangeQueryVariables = Types.Exact<{
  alert_id: Types.Scalars['ID']['input'];
}>;

export type GetLastAlertingStateChangeQuery = {
  __typename?: 'Query';
  last_alerting_state_change?: {
    __typename?: 'AlertStateChange';
    timestamp: any;
    state: Types.AlertState;
    groupByKey: string;
  } | null;
};

export type GetAlertingAlertGroupStatesQueryVariables = Types.Exact<{
  alert_id: Types.Scalars['ID']['input'];
  start_date: Types.Scalars['Timestamp']['input'];
  end_date: Types.Scalars['Timestamp']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  count?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetAlertingAlertGroupStatesQuery = {
  __typename?: 'Query';
  alerting_alert_group_states: {
    __typename?: 'AlertGroupStateResults';
    total_count: any;
    states: Array<{
      __typename?: 'AlertGroupState';
      group_by_key: string;
      current_state: Types.AlertGroupStateValue;
      last_state: Types.AlertGroupStateValue;
      created_at: any;
      investigation_conversation_id?: string | null;
    }>;
  };
};

export type GetLastAlertGroupStatesQueryVariables = Types.Exact<{
  alert_id: Types.Scalars['ID']['input'];
}>;

export type GetLastAlertGroupStatesQuery = {
  __typename?: 'Query';
  last_alert_group_states: Array<{
    __typename?: 'AlertGroupState';
    group_by_key: string;
    current_state: Types.AlertGroupStateValue;
    last_state: Types.AlertGroupStateValue;
    created_at: any;
    last_notified_at?: any | null;
  }>;
};

export type GetLastAlertingAlertGroupStateQueryVariables = Types.Exact<{
  alert_id: Types.Scalars['ID']['input'];
}>;

export type GetLastAlertingAlertGroupStateQuery = {
  __typename?: 'Query';
  last_alerting_alert_group_state?: {
    __typename?: 'AlertGroupState';
    group_by_key: string;
    current_state: Types.AlertGroupStateValue;
    last_state: Types.AlertGroupStateValue;
    created_at: any;
  } | null;
};

export type GetCustomerPortalUrlQueryVariables = Types.Exact<{
  workspace_id: Types.Scalars['ID']['input'];
}>;

export type GetCustomerPortalUrlQuery = { __typename?: 'Query'; customer_portal_url: string };

export type OnSessionPayloadAppendedSubscriptionVariables = Types.Exact<{
  session_secure_id: Types.Scalars['String']['input'];
  initial_events_count: Types.Scalars['Int']['input'];
}>;

export type OnSessionPayloadAppendedSubscription = {
  __typename?: 'Subscription';
  session_payload_appended?: {
    __typename?: 'SessionPayload';
    events: Array<any | null>;
    last_user_interaction_time: any;
    errors: Array<{
      __typename?: 'ErrorObject';
      id: any;
      error_group_secure_id: string;
      event: Array<string | null>;
      type: string;
      url: string;
      source?: string | null;
      stack_trace: string;
      timestamp: any;
      payload?: string | null;
      request_id?: string | null;
      structured_stack_trace: Array<{
        __typename?: 'ErrorTrace';
        fileName?: string | null;
        lineNumber?: number | null;
        functionName?: string | null;
        columnNumber?: number | null;
      } | null>;
    } | null>;
    rage_clicks: Array<{
      __typename?: 'RageClickEvent';
      start_timestamp: any;
      end_timestamp: any;
      total_clicks: number;
    }>;
    session_comments: Array<{
      __typename?: 'SessionComment';
      id: string;
      timestamp?: number | null;
      session_id: number;
      session_secure_id: string;
      created_at: any;
      updated_at: any;
      project_id: string;
      text: string;
      x_coordinate?: number | null;
      y_coordinate?: number | null;
      type: Types.SessionCommentType;
      metadata?: any | null;
      author?: {
        __typename?: 'SanitizedAdmin';
        id: string;
        name?: string | null;
        email: string;
        photo_url?: string | null;
      } | null;
      attachments: Array<{
        __typename?: 'ExternalAttachment';
        integration_type: Types.IntegrationType;
        external_id: string;
        title?: string | null;
      } | null>;
    } | null>;
  } | null;
};

export type GetWebVitalsQueryVariables = Types.Exact<{
  session_secure_id: Types.Scalars['String']['input'];
}>;

export type GetWebVitalsQuery = {
  __typename?: 'Query';
  web_vitals: {
    __typename?: 'MetricsBuckets';
    bucket_count: any;
    sample_factor: number;
    buckets: Array<{
      __typename?: 'MetricBucket';
      bucket_id: any;
      bucket_min?: number | null;
      bucket_max?: number | null;
      group: Array<string>;
      column: string;
      metric_type: Types.MetricAggregator;
      metric_value?: number | null;
      yhat_lower?: number | null;
      yhat_upper?: number | null;
    }>;
  };
};

export type GetSourcemapFilesQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  version?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetSourcemapFilesQuery = {
  __typename?: 'Query';
  sourcemap_files: Array<{ __typename?: 'S3File'; key?: string | null }>;
};

export type GetSourcemapVersionsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
}>;

export type GetSourcemapVersionsQuery = { __typename?: 'Query'; sourcemap_versions: Array<string> };

export type GetOAuthClientMetadataQueryVariables = Types.Exact<{
  client_id: Types.Scalars['String']['input'];
}>;

export type GetOAuthClientMetadataQuery = {
  __typename?: 'Query';
  oauth_client_metadata?: { __typename?: 'OAuthClient'; id: string; created_at: any; app_name: string } | null;
};

export type GetSsoLoginQueryVariables = Types.Exact<{
  domain: Types.Scalars['String']['input'];
}>;

export type GetSsoLoginQuery = {
  __typename?: 'Query';
  sso_login?: { __typename?: 'SSOLogin'; domain: string; client_id: string } | null;
};

export type SearchIssuesQueryVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
  query: Types.Scalars['String']['input'];
  integration_type: Types.IntegrationType;
}>;

export type SearchIssuesQuery = {
  __typename?: 'Query';
  search_issues: Array<{ __typename?: 'IssuesSearchResult'; id: string; title: string; issue_url: string }>;
};

export type GetErrorGroupTagsQueryVariables = Types.Exact<{
  error_group_secure_id: Types.Scalars['String']['input'];
  use_clickhouse?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  date_range?: Types.InputMaybe<Types.DateRangeInput>;
}>;

export type GetErrorGroupTagsQuery = {
  __typename?: 'Query';
  errorGroupTags: Array<{
    __typename?: 'ErrorGroupTagAggregation';
    key: string;
    buckets: Array<{ __typename?: 'ErrorGroupTagAggregationBucket'; key: string; doc_count: any; percent: number }>;
  }>;
};

export type GetEmailOptOutsQueryVariables = Types.Exact<{
  token?: Types.InputMaybe<Types.Scalars['String']['input']>;
  admin_id?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type GetEmailOptOutsQuery = { __typename?: 'Query'; email_opt_outs: Array<Types.EmailOptOutCategory> };

export type GetLogsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  params: Types.QueryInput;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  at?: Types.InputMaybe<Types.Scalars['String']['input']>;
  direction: Types.SortDirection;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  query_settings?: Types.InputMaybe<Types.QuerySettingsInput>;
}>;

export type GetLogsQuery = {
  __typename?: 'Query';
  logs: {
    __typename?: 'LogConnection';
    edges: Array<{
      __typename?: 'LogEdge';
      cursor: string;
      node: {
        __typename?: 'Log';
        timestamp: any;
        level: Types.LogLevel;
        message: string;
        logAttributes: any;
        traceID?: string | null;
        spanID?: string | null;
        secureSessionID?: string | null;
        source?: string | null;
        serviceName?: string | null;
        serviceVersion?: string | null;
        environment?: string | null;
        projectID: number;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string;
      endCursor: string;
    };
  };
};

export type GetLogsHistogramQueryVariables = Types.Exact<{
  project_id: Types.Scalars['ID']['input'];
  params: Types.QueryInput;
}>;

export type GetLogsHistogramQuery = {
  __typename?: 'Query';
  logs_histogram: {
    __typename?: 'LogsHistogram';
    totalCount: any;
    objectCount: any;
    sampleFactor: number;
    buckets: Array<{
      __typename?: 'LogsHistogramBucket';
      bucketId: any;
      counts: Array<{ __typename?: 'LogsHistogramBucketCount'; count: any; level: Types.LogLevel }>;
    }>;
  };
};

export type GetLogsRelatedResourcesQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  log_cursors: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  trace_ids: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  date_range: Types.DateRangeRequiredInput;
}>;

export type GetLogsRelatedResourcesQuery = {
  __typename?: 'Query';
  existing_logs_traces: Array<string>;
  logs_error_objects: Array<{
    __typename?: 'ErrorObject';
    log_cursor?: string | null;
    error_group_secure_id: string;
    id: any;
  }>;
};

export type GetProjectSettingsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['StringID']['input'];
}>;

export type GetProjectSettingsQuery = {
  __typename?: 'Query';
  projectSettings?: {
    __typename?: 'AllProjectSettings';
    id: string;
    name: string;
    verbose_id: string;
    billing_email?: string | null;
    excluded_users?: any | null;
    error_filters?: any | null;
    error_json_paths?: any | null;
    filter_chrome_extension?: boolean | null;
    rage_click_window_seconds?: number | null;
    rage_click_radius_pixels?: number | null;
    rage_click_count?: number | null;
    filterSessionsWithoutError: boolean;
    autoResolveStaleErrorsDayInterval: number;
    sampling: {
      __typename?: 'Sampling';
      session_sampling_rate: number;
      error_sampling_rate: number;
      log_sampling_rate: number;
      trace_sampling_rate: number;
      metric_sampling_rate: number;
      session_exclusion_query?: string | null;
      error_exclusion_query?: string | null;
      log_exclusion_query?: string | null;
      trace_exclusion_query?: string | null;
      metric_exclusion_query?: string | null;
      session_minute_rate_limit?: any | null;
      error_minute_rate_limit?: any | null;
      log_minute_rate_limit?: any | null;
      trace_minute_rate_limit?: any | null;
      metric_minute_rate_limit?: any | null;
    };
    filter_rules?: {
      __typename?: 'ProjectFilterRules';
      session_filter_rules_order: Array<string>;
      error_filter_rules_order: Array<string>;
      log_filter_rules_order: Array<string>;
      trace_filter_rules_order: Array<string>;
    } | null;
  } | null;
};

export type GetWorkspacePendingInvitesQueryVariables = Types.Exact<{
  workspace_id: Types.Scalars['ID']['input'];
}>;

export type GetWorkspacePendingInvitesQuery = {
  __typename?: 'Query';
  workspacePendingInvites: Array<{
    __typename?: 'WorkspaceInviteLink';
    id: string;
    invitee_email?: string | null;
    invitee_role: string;
    created_at: any;
  } | null>;
};

export type GetErrorResolutionSuggestionQueryVariables = Types.Exact<{
  error_object_id: Types.Scalars['ID']['input'];
}>;

export type GetErrorResolutionSuggestionQuery = { __typename?: 'Query'; error_resolution_suggestion: string };

export type GetWorkspaceSettingsQueryVariables = Types.Exact<{
  workspace_id: Types.Scalars['ID']['input'];
}>;

export type GetWorkspaceSettingsQuery = {
  __typename?: 'Query';
  workspaceSettings?: {
    __typename?: 'AllWorkspaceSettings';
    workspace_id: string;
    ai_insights: boolean;
    enable_billing_limits: boolean;
    enable_business_dashboards: boolean;
    enable_business_projects: boolean;
    enable_business_retention: boolean;
    enable_business_seats: boolean;
    enable_data_deletion: boolean;
    enable_grafana_dashboard: boolean;
    enable_ingest_filtering: boolean;
    enable_ingest_sampling: boolean;
    enable_jira_integration: boolean;
    enable_network_traces: boolean;
    enable_project_level_access: boolean;
    enable_session_export: boolean;
    enable_sso: boolean;
    enable_teams_integration: boolean;
    enable_unlisted_sharing: boolean;
  } | null;
};

export type GetSystemConfigurationQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetSystemConfigurationQuery = {
  __typename?: 'Query';
  system_configuration: {
    __typename?: 'SystemConfiguration';
    maintenance_start?: any | null;
    maintenance_end?: any | null;
  };
};

export type GetErrorGroupInstancesQueryVariables = Types.Exact<{
  errorGroupSecureID: Types.Scalars['String']['input'];
  count: Types.Scalars['Int']['input'];
  params: Types.QueryInput;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetErrorGroupInstancesQuery = {
  __typename?: 'Query';
  error_objects: {
    __typename?: 'ErrorObjectResults';
    totalCount: any;
    error_objects: Array<{
      __typename?: 'ErrorObjectNode';
      id: any;
      createdAt: any;
      event: string;
      timestamp: any;
      serviceVersion: string;
      serviceName: string;
      errorGroupSecureID: string;
      project_id: number;
      session?: {
        __typename?: 'ErrorObjectNodeSession';
        secureID: string;
        email?: string | null;
        fingerprint?: number | null;
        excluded: boolean;
      } | null;
    }>;
  };
};

export type GetErrorObjectsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['String']['input'];
  count: Types.Scalars['Int']['input'];
  params: Types.QueryInput;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  query_settings?: Types.InputMaybe<Types.QuerySettingsInput>;
}>;

export type GetErrorObjectsQuery = {
  __typename?: 'Query';
  error_objects: {
    __typename?: 'ErrorObjectResults';
    totalCount: any;
    error_objects: Array<{
      __typename?: 'ErrorObjectNode';
      id: any;
      createdAt: any;
      event: string;
      timestamp: any;
      serviceVersion: string;
      serviceName: string;
      errorGroupSecureID: string;
      project_id: number;
      session?: {
        __typename?: 'ErrorObjectNodeSession';
        secureID: string;
        email?: string | null;
        fingerprint?: number | null;
        excluded: boolean;
      } | null;
    }>;
  };
};

export type GetServicesQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetServicesQuery = {
  __typename?: 'Query';
  services?: {
    __typename?: 'ServiceConnection';
    edges: Array<{
      __typename?: 'ServiceEdge';
      cursor: string;
      node: {
        __typename?: 'ServiceNode';
        id: any;
        projectID: string;
        name: string;
        status: Types.ServiceStatus;
        githubRepoPath?: string | null;
        buildPrefix?: string | null;
        githubPrefix?: string | null;
        errorDetails?: Array<string> | null;
      };
    } | null>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string;
      endCursor: string;
    };
  } | null;
};

export type GetServiceByNameQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  name: Types.Scalars['String']['input'];
}>;

export type GetServiceByNameQuery = {
  __typename?: 'Query';
  serviceByName?: {
    __typename?: 'Service';
    id: any;
    projectID: string;
    name: string;
    status: Types.ServiceStatus;
    githubRepoPath?: string | null;
    buildPrefix?: string | null;
    githubPrefix?: string | null;
    errorDetails?: Array<string> | null;
  } | null;
};

export type GetTraceQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  trace_id: Types.Scalars['String']['input'];
  timestamp: Types.Scalars['Timestamp']['input'];
  session_secure_id?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetTraceQuery = {
  __typename?: 'Query';
  trace?: {
    __typename?: 'TracePayload';
    trace: Array<{
      __typename?: 'Trace';
      timestamp: any;
      traceID: string;
      spanID: string;
      parentSpanID: string;
      projectID: number;
      secureSessionID: string;
      traceState: string;
      spanName: string;
      spanKind: string;
      duration: number;
      serviceName: string;
      serviceVersion: string;
      environment: string;
      environmentId?: string | null;
      hasErrors: boolean;
      traceAttributes: any;
      startTime: number;
      statusCode: string;
      statusMessage: string;
      events?: Array<{ __typename?: 'TraceEvent'; timestamp: any; name: string; attributes: any } | null> | null;
    }>;
    errors: Array<{
      __typename?: 'TraceError';
      created_at: any;
      id: string;
      trace_id?: string | null;
      span_id?: string | null;
      log_cursor?: string | null;
      event: string;
      type: string;
      source: string;
      timestamp: any;
      error_group_secure_id: string;
    }>;
  } | null;
};

export type GetTraceConversationQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  conversation_id: Types.Scalars['String']['input'];
  start_date?: Types.InputMaybe<Types.Scalars['Timestamp']['input']>;
  end_date?: Types.InputMaybe<Types.Scalars['Timestamp']['input']>;
}>;

export type GetTraceConversationQuery = {
  __typename?: 'Query';
  trace_conversation?: {
    __typename?: 'TraceConversationPayload';
    conversation_id: string;
    spans: Array<{
      __typename?: 'Trace';
      timestamp: any;
      traceID: string;
      spanID: string;
      parentSpanID: string;
      projectID: number;
      secureSessionID: string;
      traceState: string;
      spanName: string;
      spanKind: string;
      duration: number;
      serviceName: string;
      serviceVersion: string;
      environment: string;
      environmentId?: string | null;
      hasErrors: boolean;
      traceAttributes: any;
      startTime: number;
      statusCode: string;
      statusMessage: string;
      events?: Array<{ __typename?: 'TraceEvent'; timestamp: any; name: string; attributes: any } | null> | null;
    }>;
    summary: {
      __typename?: 'ConversationSummary';
      trace_count: number;
      span_count: number;
      total_duration_ns: number;
      input_tokens: number;
      output_tokens: number;
    };
  } | null;
};

export type GetTracesQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  params: Types.QueryInput;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  at?: Types.InputMaybe<Types.Scalars['String']['input']>;
  direction: Types.SortDirection;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  omitBody?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  query_settings?: Types.InputMaybe<Types.QuerySettingsInput>;
}>;

export type GetTracesQuery = {
  __typename?: 'Query';
  traces: {
    __typename?: 'TraceConnection';
    sampled: boolean;
    edges: Array<{
      __typename?: 'TraceEdge';
      cursor: string;
      node: {
        __typename?: 'Trace';
        timestamp: any;
        traceID: string;
        spanID: string;
        parentSpanID: string;
        projectID: number;
        secureSessionID: string;
        traceState: string;
        spanName: string;
        spanKind: string;
        duration: number;
        serviceName: string;
        serviceVersion: string;
        environment: string;
        hasErrors: boolean;
        traceAttributes: any;
        statusCode: string;
        statusMessage: string;
        events?: Array<{ __typename?: 'TraceEvent'; timestamp: any; name: string; attributes: any } | null> | null;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string;
      endCursor: string;
    };
  };
};

export type GetTraceSummariesQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  params: Types.QueryInput;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetTraceSummariesQuery = {
  __typename?: 'Query';
  traceSummaries: {
    __typename?: 'TraceSummaryConnection';
    sampled: boolean;
    edges: Array<{
      __typename?: 'TraceSummaryEdge';
      cursor: string;
      node: {
        __typename?: 'TraceSummary';
        timestamp: any;
        traceID: string;
        root_name: string;
        root_service: string;
        services_touched: Array<string>;
        span_count: any;
        trace_duration: any;
        error_count: any;
        in_progress: boolean;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string;
      endCursor: string;
    };
  };
};

export type GetConversationsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  params: Types.QueryInput;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetConversationsQuery = {
  __typename?: 'Query';
  traceConversations: {
    __typename?: 'ConversationConnection';
    sampled: boolean;
    edges: Array<{
      __typename?: 'ConversationEdge';
      cursor: string;
      node: {
        __typename?: 'Conversation';
        projectID: number;
        conversationID: string;
        timestamp: any;
        first_timestamp: any;
        last_timestamp: any;
        active_duration_ns: any;
        trace_count: any;
        span_count: any;
        models: Array<string>;
        providers: Array<string>;
        input_tokens: any;
        output_tokens: any;
        error_count: any;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string;
      endCursor: string;
    };
  };
};

export type GetTracesMetricsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  params: Types.QueryInput;
  column: Types.Scalars['String']['input'];
  metric_types: Array<Types.MetricAggregator> | Types.MetricAggregator;
  group_by: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  bucket_by?: Types.InputMaybe<Types.Scalars['String']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit_aggregator?: Types.InputMaybe<Types.MetricAggregator>;
  limit_column?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetTracesMetricsQuery = {
  __typename?: 'Query';
  traces_metrics: {
    __typename?: 'MetricsBuckets';
    bucket_count: any;
    sample_factor: number;
    buckets: Array<{
      __typename?: 'MetricBucket';
      bucket_id: any;
      group: Array<string>;
      metric_type: Types.MetricAggregator;
      metric_value?: number | null;
    }>;
  };
};

export type GetKeysQueryVariables = Types.Exact<{
  product_type?: Types.InputMaybe<Types.ProductType>;
  project_id: Types.Scalars['StringID']['input'];
  date_range: Types.DateRangeRequiredInput;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  type?: Types.InputMaybe<Types.KeyType>;
  event?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetKeysQuery = {
  __typename?: 'Query';
  keys: Array<{ __typename?: 'QueryKey'; name: string; type: Types.KeyType; count: any }>;
};

export type GetKeyValuesQueryVariables = Types.Exact<{
  product_type?: Types.InputMaybe<Types.ProductType>;
  project_id: Types.Scalars['StringID']['input'];
  key_name: Types.Scalars['String']['input'];
  date_range: Types.DateRangeRequiredInput;
  query: Types.Scalars['String']['input'];
  count: Types.Scalars['Int']['input'];
  event?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetKeyValuesQuery = { __typename?: 'Query'; key_values: Array<string> };

export type GetKeyValueSuggestionsQueryVariables = Types.Exact<{
  product_type: Types.ProductType;
  project_id: Types.Scalars['StringID']['input'];
  date_range: Types.DateRangeRequiredInput;
  keys: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;

export type GetKeyValueSuggestionsQuery = {
  __typename?: 'Query';
  key_values_suggestions: Array<{
    __typename?: 'KeyValueSuggestion';
    key: string;
    values: Array<{ __typename?: 'ValueSuggestion'; value: string; count: any; rank: any }>;
  }>;
};

export type GetValueSuggestionsQueryVariables = Types.Exact<{
  product_type?: Types.InputMaybe<Types.ProductType>;
  project_id: Types.Scalars['StringID']['input'];
  key_name: Types.Scalars['String']['input'];
  date_range: Types.DateRangeRequiredInput;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  count?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  event?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetValueSuggestionsQuery = {
  __typename?: 'Query';
  value_suggestions: Array<{ __typename?: 'ValueSuggestion'; value: string; count: any; rank: any }>;
};

export type GetUrlKeyValuesQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  date_range: Types.DateRangeRequiredInput;
  query: Types.Scalars['String']['input'];
  count: Types.Scalars['Int']['input'];
}>;

export type GetUrlKeyValuesQuery = {
  __typename?: 'Query';
  url_key_values: Array<{ __typename?: 'URLKeyValue'; key: string; value: string; count: number }>;
};

export type GetMetricsQueryVariables = Types.Exact<{
  product_type: Types.ProductType;
  project_id: Types.Scalars['StringID']['input'];
  params: Types.QueryInput;
  sql?: Types.InputMaybe<Types.Scalars['String']['input']>;
  group_by: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  bucket_by: Types.Scalars['String']['input'];
  bucket_count?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  bucket_window?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit_aggregator?: Types.InputMaybe<Types.MetricAggregator>;
  limit_column?: Types.InputMaybe<Types.Scalars['String']['input']>;
  prediction_settings?: Types.InputMaybe<Types.PredictionSettings>;
  expressions: Array<Types.MetricExpressionInput> | Types.MetricExpressionInput;
  population_function_type?: Types.InputMaybe<Types.MetricAggregator>;
  population_query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  population_window?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  query_settings?: Types.InputMaybe<Types.QuerySettingsInput>;
  include_null_or_empty_groups?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type GetMetricsQuery = {
  __typename?: 'Query';
  metrics: {
    __typename?: 'MetricsBuckets';
    bucket_count: any;
    sample_factor: number;
    metric_unit?: string | null;
    buckets: Array<{
      __typename?: 'MetricBucket';
      bucket_id: any;
      bucket_min?: number | null;
      bucket_max?: number | null;
      bucket_value?: number | null;
      group: Array<string>;
      column: string;
      metric_type: Types.MetricAggregator;
      metric_value?: number | null;
      yhat_lower?: number | null;
      yhat_upper?: number | null;
    }>;
    ingest_delay?: { __typename?: 'IngestDelay'; p50: number; p90: number; p100: number } | null;
    query_stats?: { __typename?: 'QueryStats'; rows_scanned: any; rows_matched: any; was_sampled: boolean } | null;
  };
};

export type GetGraphTemplatesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetGraphTemplatesQuery = {
  __typename?: 'Query';
  graph_templates: Array<{
    __typename?: 'Graph';
    id: string;
    type: string;
    title: string;
    description: string;
    productType: Types.ProductType;
    query: string;
    groupByKeys?: any | null;
    bucketByKey?: string | null;
    bucketCount?: number | null;
    bucketInterval?: number | null;
    limit?: number | null;
    limitFunctionType?: Types.MetricAggregator | null;
    limitMetric?: string | null;
    display?: string | null;
    comparisonMode?: string | null;
    strictOrder?: boolean | null;
    breakdownBy?: any | null;
    breakdownLimit?: number | null;
    nullHandling?: string | null;
    showExemplars?: boolean | null;
    exemplarScaleMode?: string | null;
    sql?: string | null;
    funnelSteps?: Array<{ __typename?: 'FunnelStep'; title: string; query: string }> | null;
    expressions: Array<{ __typename?: 'MetricExpression'; aggregator: Types.MetricAggregator; column: string }>;
  }>;
};

export type GetVisualizationQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetVisualizationQuery = {
  __typename?: 'Query';
  visualization: {
    __typename?: 'Visualization';
    id: string;
    updatedAt: any;
    projectId: string;
    name: string;
    timePreset?: string | null;
    kind: Types.DashboardKind;
    briefContent?: string | null;
    variables: Array<{
      __typename?: 'Variable';
      key: string;
      defaultValues: Array<string>;
      suggestionType: Types.SuggestionType;
      field?: string | null;
    }>;
    graphs: Array<{
      __typename?: 'Graph';
      id: string;
      type: string;
      title: string;
      description: string;
      productType: Types.ProductType;
      query: string;
      groupByKeys?: any | null;
      bucketByKey?: string | null;
      bucketCount?: number | null;
      bucketInterval?: number | null;
      limit?: number | null;
      limitFunctionType?: Types.MetricAggregator | null;
      limitMetric?: string | null;
      display?: string | null;
      comparisonMode?: string | null;
      strictOrder?: boolean | null;
      breakdownBy?: any | null;
      breakdownLimit?: number | null;
      nullHandling?: string | null;
      showExemplars?: boolean | null;
      exemplarScaleMode?: string | null;
      sql?: string | null;
      heatmapSecureSessionId?: string | null;
      heatmapSessionTimestamp?: any | null;
      funnelSteps?: Array<{ __typename?: 'FunnelStep'; title: string; query: string }> | null;
      expressions: Array<{ __typename?: 'MetricExpression'; aggregator: Types.MetricAggregator; column: string }>;
    }>;
    updatedByAdmin?: {
      __typename?: 'SanitizedAdmin';
      id: string;
      name?: string | null;
      email: string;
      photo_url?: string | null;
    } | null;
  };
};

export type GetVisualizationsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  input: Types.Scalars['String']['input'];
  count: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
}>;

export type GetVisualizationsQuery = {
  __typename?: 'Query';
  visualizations: {
    __typename?: 'VisualizationsResponse';
    count: number;
    results: Array<{
      __typename?: 'Visualization';
      id: string;
      updatedAt: any;
      projectId: string;
      name: string;
      timePreset?: string | null;
      kind: Types.DashboardKind;
      briefContent?: string | null;
      variables: Array<{
        __typename?: 'Variable';
        key: string;
        defaultValues: Array<string>;
        suggestionType: Types.SuggestionType;
        field?: string | null;
      }>;
      graphs: Array<{
        __typename?: 'Graph';
        id: string;
        type: string;
        title: string;
        productType: Types.ProductType;
        query: string;
        groupByKeys?: any | null;
        bucketByKey?: string | null;
        bucketCount?: number | null;
        bucketInterval?: number | null;
        limit?: number | null;
        limitFunctionType?: Types.MetricAggregator | null;
        limitMetric?: string | null;
        display?: string | null;
        comparisonMode?: string | null;
        strictOrder?: boolean | null;
        breakdownBy?: any | null;
        breakdownLimit?: number | null;
        nullHandling?: string | null;
        showExemplars?: boolean | null;
        exemplarScaleMode?: string | null;
        sql?: string | null;
        heatmapSecureSessionId?: string | null;
        heatmapSessionTimestamp?: any | null;
        funnelSteps?: Array<{ __typename?: 'FunnelStep'; title: string; query: string }> | null;
        expressions: Array<{ __typename?: 'MetricExpression'; aggregator: Types.MetricAggregator; column: string }>;
      }>;
      updatedByAdmin?: {
        __typename?: 'SanitizedAdmin';
        id: string;
        name?: string | null;
        email: string;
        photo_url?: string | null;
      } | null;
    }>;
  };
};

export type GetAiQuerySuggestionQueryVariables = Types.Exact<{
  time_zone: Types.Scalars['String']['input'];
  project_id: Types.Scalars['StringID']['input'];
  product_type: Types.ProductType;
  query: Types.Scalars['String']['input'];
}>;

export type GetAiQuerySuggestionQuery = {
  __typename?: 'Query';
  ai_query_suggestion: {
    __typename?: 'QueryOutput';
    query: string;
    date_range: { __typename?: 'DateRangeRequiredOutput'; start_date?: any | null; end_date?: any | null };
  };
};

export type GetHeatmapClicksQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  params: Types.QueryInput;
}>;

export type GetHeatmapClicksQuery = {
  __typename?: 'Query';
  heatmap_clicks?: Array<{
    __typename?: 'ClickInformation';
    xpath: string;
    count: number;
    sessionCount: number;
    userCount: number;
    classname: string;
    elementId: string;
    tag: string;
    text: string;
    sessionInformation: Array<{ __typename?: 'ClickSessionInformation'; secureSessionID: string; timestamp: any }>;
  }> | null;
};

export type GetTimestampEventChunkUrlQueryVariables = Types.Exact<{
  secure_id: Types.Scalars['String']['input'];
  timestamp: Types.Scalars['Timestamp']['input'];
}>;

export type GetTimestampEventChunkUrlQuery = { __typename?: 'Query'; timestamp_event_chunk_url: string };

export type GetConversationHistoryQueryVariables = Types.Exact<{
  conversation_id: Types.Scalars['StringID']['input'];
  after_turn?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetConversationHistoryQuery = {
  __typename?: 'Query';
  conversation_history: {
    __typename?: 'ConversationHistoryResponse';
    status: string;
    error?: string | null;
    messages: Array<{
      __typename?: 'ConversationMessage';
      id: string;
      conversation_id: any;
      role: string;
      content: any;
      turn: number;
      tokens_used?: number | null;
      is_final: boolean;
      created_at: any;
    }>;
  };
};

export type GetClickSessionsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  count: Types.Scalars['Int']['input'];
  params: Types.QueryInput;
  sort_desc: Types.Scalars['Boolean']['input'];
  sort_field?: Types.InputMaybe<Types.Scalars['String']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetClickSessionsQuery = {
  __typename?: 'Query';
  click_sessions: {
    __typename?: 'SessionResults';
    totalCount: any;
    sessions: Array<{
      __typename?: 'Session';
      id: any;
      secure_id: string;
      client_id: string;
      fingerprint?: number | null;
      identifier: string;
      identified: boolean;
      os_name: string;
      os_version: string;
      browser_name: string;
      browser_version: string;
      ip: string;
      city: string;
      state: string;
      country: string;
      postal: string;
      created_at: any;
      language: string;
      length?: number | null;
      active_length?: number | null;
      enable_recording_network_contents?: boolean | null;
      viewed?: boolean | null;
      starred?: boolean | null;
      processed?: boolean | null;
      has_rage_clicks?: boolean | null;
      has_errors?: boolean | null;
      first_time?: boolean | null;
      user_properties?: string | null;
      event_counts?: string | null;
      last_user_interaction_time: any;
      is_public: boolean;
      excluded: boolean;
      email?: string | null;
      fields?: Array<{
        __typename?: 'Field';
        name: string;
        value: string;
        type?: string | null;
        id: any;
      } | null> | null;
    }>;
  };
};

export type GetAiChatLimitStatusQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
}>;

export type GetAiChatLimitStatusQuery = {
  __typename?: 'Query';
  aiChatLimitStatus: { __typename?: 'AIChatLimitStatus'; current_count: any; limit: any; workspace_id: string };
};

export type GetFilterRulesQueryVariables = Types.Exact<{
  projectId: Types.Scalars['StringID']['input'];
  productType: Types.ProductType;
}>;

export type GetFilterRulesQuery = {
  __typename?: 'Query';
  filterRules: {
    __typename?: 'FilterRulesResponse';
    rules_order: Array<string>;
    rules: Array<{
      __typename?: 'FilterRuleDetails';
      rule: {
        __typename?: 'QueryFilterRule';
        id: any;
        rule_name: string;
        is_rule_enabled: boolean;
        product_type: Types.ProductType;
        project_id: string;
        query: string;
        filter_operation: Types.FilterOperationType;
        filter_operation_rate: number;
        attributes: Array<string>;
        created_at: any;
        updated_at: any;
      };
    }>;
  };
};

export type GetQueryFilterRuleQueryVariables = Types.Exact<{
  id: Types.Scalars['StringID']['input'];
  projectId: Types.Scalars['StringID']['input'];
}>;

export type GetQueryFilterRuleQuery = {
  __typename?: 'Query';
  queryFilterRule: {
    __typename?: 'QueryFilterRuleDetails';
    rule: {
      __typename?: 'QueryFilterRule';
      id: any;
      rule_name: string;
      is_rule_enabled: boolean;
      product_type: Types.ProductType;
      project_id: string;
      query: string;
      filter_operation: Types.FilterOperationType;
      filter_operation_rate: number;
      attributes: Array<string>;
      created_at: any;
      updated_at: any;
    };
  };
};

export type GetServiceMapQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  date_range: Types.DateRangeRequiredInput;
}>;

export type GetServiceMapQuery = {
  __typename?: 'Query';
  serviceMap: Array<{ __typename?: 'ServiceDependency'; source: string; target?: string | null }>;
};

export type GetTraceServiceSummaryQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  params: Types.TraceServiceSummaryParamsInput;
}>;

export type GetTraceServiceSummaryQuery = {
  __typename?: 'Query';
  traceServiceSummary: {
    __typename?: 'TraceServiceSummaryResult';
    buckets: Array<{
      __typename?: 'TraceServiceSummaryBucket';
      service_name: string;
      time_bucket: any;
      request_count: any;
      error_count: any;
    }>;
  };
};

export type GetServiceConnectionsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  service_name: Types.Scalars['String']['input'];
  date_range: Types.DateRangeRequiredInput;
  environment_ids?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;

export type GetServiceConnectionsQuery = {
  __typename?: 'Query';
  serviceConnections: { __typename?: 'ServiceConnections'; incoming: Array<string>; outgoing: Array<string> };
};

export type GetAiConversationHistoryQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  count: Types.Scalars['Int']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  user_email?: Types.InputMaybe<Types.Scalars['String']['input']>;
  date_range?: Types.InputMaybe<Types.DateRangeInput>;
  tag_key?: Types.InputMaybe<Types.Scalars['String']['input']>;
  tag_value?: Types.InputMaybe<Types.Scalars['String']['input']>;
  shared_only?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  origin?: Types.InputMaybe<Types.AgentConversationOrigin>;
  agent_kind?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetAiConversationHistoryQuery = {
  __typename?: 'Query';
  aiConversationHistory: {
    __typename?: 'AIConversationHistoryResults';
    totalCount: any;
    conversations: Array<{
      __typename?: 'AIConversationSummary';
      conversation_id: any;
      user_email: string;
      user_message_count: number;
      agent_message_count: number;
      initiated_at: any;
      last_user_message_at: any;
      message_preview: string;
      title?: string | null;
      status: string;
      agent_kind?: string | null;
      origin: Types.AgentConversationOrigin;
      is_shared: boolean;
      tags?: Array<{ __typename?: 'ConversationTag'; key: string; value: string }> | null;
    }>;
  };
};

export type GetAgentArtifactQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  type: Types.Scalars['String']['input'];
  external_id: Types.Scalars['String']['input'];
}>;

export type GetAgentArtifactQuery = {
  __typename?: 'Query';
  agentArtifact?: {
    __typename?: 'ArtifactDetail';
    artifact: {
      __typename?: 'Artifact';
      id: string;
      type: string;
      external_id: string;
      title?: string | null;
      url?: string | null;
      status?: string | null;
      created_at: any;
      updated_at: any;
    };
    events: Array<{
      __typename?: 'ArtifactEvent';
      id: string;
      event_type: string;
      status?: string | null;
      conversation_id?: any | null;
      payload?: any | null;
      created_at: any;
    }>;
    conversation_links: Array<{
      __typename?: 'ArtifactConversationLink';
      conversation_id: any;
      user_email: string;
      is_shared: boolean;
      relationship: string;
      source?: string | null;
      linked_at: any;
      message_preview: string;
      title?: string | null;
    }>;
    github_pull_request?: {
      __typename?: 'ArtifactPullRequest';
      owner: string;
      repo: string;
      number: number;
      title: string;
      body?: string | null;
      state: string;
      merged: boolean;
      draft: boolean;
      html_url: string;
      created_at: any;
      updated_at: any;
      reviews: Array<{
        __typename?: 'ArtifactPullRequestReview';
        user: string;
        state: string;
        submitted_at?: any | null;
      }>;
      checks: {
        __typename?: 'ArtifactPullRequestChecks';
        total: number;
        success: number;
        failure: number;
        pending: number;
        neutral: number;
      };
      timeline: Array<{
        __typename?: 'ArtifactPullRequestTimelineEvent';
        type: string;
        actor: string;
        at: any;
        title?: string | null;
        url?: string | null;
      }>;
    } | null;
  } | null;
};

export type GetProjectArtifactsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  type?: Types.InputMaybe<Types.Scalars['String']['input']>;
  source?: Types.InputMaybe<Types.Scalars['String']['input']>;
  count: Types.Scalars['Int']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  creator?: Types.InputMaybe<Types.ArtifactCreatorFilter>;
}>;

export type GetProjectArtifactsQuery = {
  __typename?: 'Query';
  projectArtifacts: {
    __typename?: 'ArtifactResults';
    totalCount: any;
    artifacts: Array<{
      __typename?: 'Artifact';
      id: string;
      type: string;
      external_id: string;
      title?: string | null;
      url?: string | null;
      status?: string | null;
      updated_at: any;
    }>;
  };
};

export type GetConversationArtifactsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  conversation_id: Types.Scalars['String']['input'];
  relationships?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetConversationArtifactsQuery = {
  __typename?: 'Query';
  conversationArtifacts: Array<{
    __typename?: 'Artifact';
    id: string;
    type: string;
    external_id: string;
    title?: string | null;
    url?: string | null;
    status?: string | null;
    created_at: any;
    updated_at: any;
  }>;
};

export type GetFlagCleanupsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  count: Types.Scalars['Int']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  date_range?: Types.InputMaybe<Types.DateRangeInput>;
}>;

export type GetFlagCleanupsQuery = {
  __typename?: 'Query';
  flagCleanups: {
    __typename?: 'FlagCleanupResults';
    totalCount: any;
    flag_cleanups: Array<{ __typename?: 'FlagCleanup'; flag_name: string; pr_link: string; cleaned_at: any }>;
  };
};

export type GetVegaSlackConfigurationQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetVegaSlackConfigurationQuery = {
  __typename?: 'Query';
  vega_slack_configuration?: {
    __typename?: 'VegaSlackConfiguration';
    id: string;
    admin_id: number;
    permission_mode?: string | null;
    investigation_prompt?: string | null;
    investigation_project_id?: string | null;
    investigation_repositories?: any | null;
  } | null;
};

export type GetVegaProjectConfigurationQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
}>;

export type GetVegaProjectConfigurationQuery = {
  __typename?: 'Query';
  vega_project_configuration?: {
    __typename?: 'VegaProjectConfiguration';
    id: string;
    project_id: number;
    pull_request_title_prefix: string;
    pull_request_bot_identity_workflows: Array<Types.VegaPullRequestBotIdentityWorkflow>;
  } | null;
};

export type GetDashboardOptionsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetDashboardOptionsQuery = {
  __typename?: 'Query';
  dashboard_options: Array<{ __typename?: 'FilterOption'; id: string; name: string }>;
};

export type GetGraphOptionsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  dashboard_id?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetGraphOptionsQuery = {
  __typename?: 'Query';
  graph_options: Array<{ __typename?: 'FilterOption'; id: string; name: string }>;
};

export type GetAlertOptionsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetAlertOptionsQuery = {
  __typename?: 'Query';
  alert_options: Array<{ __typename?: 'FilterOption'; id: string; name: string }>;
};

export type GetPaEventsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  params: Types.QueryInput;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  at?: Types.InputMaybe<Types.Scalars['String']['input']>;
  direction: Types.SortDirection;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  query_settings?: Types.InputMaybe<Types.QuerySettingsInput>;
}>;

export type GetPaEventsQuery = {
  __typename?: 'Query';
  pa_events: {
    __typename?: 'PAEventConnection';
    sampled: boolean;
    edges: Array<{
      __typename?: 'PAEventEdge';
      cursor: string;
      node: {
        __typename?: 'PAEvent';
        type: string;
        timestamp: any;
        attributes: any;
        secureSessionID: string;
        contextKeys: any;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string;
      endCursor: string;
    };
  };
};

export type GetPaEventsFunnelQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  params: Types.QueryInput;
  funnel_steps: Array<Types.FunnelStepInput> | Types.FunnelStepInput;
  group_by: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  strict_order?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type GetPaEventsFunnelQuery = {
  __typename?: 'Query';
  pa_events_funnel: {
    __typename?: 'FunnelResults';
    steps: Array<{ __typename?: 'FunnelStepResult'; step_index: number; count: number }>;
  };
};

export type GetPaEventsFunnelV2QueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  params: Types.QueryInput;
  funnel_steps: Array<Types.FunnelStepInput> | Types.FunnelStepInput;
  group_by: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  strict_order?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  breakdown_by: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  breakdown_limit: Types.Scalars['Int']['input'];
}>;

export type GetPaEventsFunnelV2Query = {
  __typename?: 'Query';
  pa_events_funnel_v2: {
    __typename?: 'FunnelResultsV2';
    groups: Array<{
      __typename?: 'FunnelGroupResult';
      groupValues: Array<string>;
      steps: Array<{ __typename?: 'FunnelStepResult'; step_index: number; count: number }>;
    }>;
  };
};

export type GetTeamQueryHistoryQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  query_type: Types.ProductType;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetTeamQueryHistoryQuery = {
  __typename?: 'Query';
  team_query_history: Array<{
    __typename?: 'TeamQueryHistoryEntry';
    id: string;
    executedAt: any;
    queryType: Types.ProductType;
    queryText: string;
    dateRangeStart: any;
    dateRangeEnd: any;
    resultCount?: any | null;
    admin: {
      __typename?: 'SanitizedAdmin';
      id: string;
      name?: string | null;
      email: string;
      photo_url?: string | null;
    };
    parsedFilters: {
      __typename?: 'ParsedQueryFilters';
      body: Array<string>;
      attributes: Array<{ __typename?: 'QueryAttributeFilter'; key: string; values: Array<string> }>;
    };
    chartPreview: Array<{ __typename?: 'ChartPreviewBucket'; bucketStart: any; bucketEnd: any; count: number }>;
  }>;
};

export type GetMetricExemplarsQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  params: Types.QueryInput;
  bucket_window?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetMetricExemplarsQuery = {
  __typename?: 'Query';
  metric_exemplars: {
    __typename?: 'MetricExemplarsResult';
    exemplar_window_start: any;
    truncated_to_horizon: boolean;
    exemplars: Array<{
      __typename?: 'MetricRowExemplar';
      timestamp: any;
      value: number;
      traceID: string;
      spanID: string;
      secureSessionID: string;
      attributes: any;
      metric_name: string;
    }>;
  };
};

export type ExperimentHypothesisSuggestionQueryVariables = Types.Exact<{
  project_id: Types.Scalars['StringID']['input'];
  prompt: Types.Scalars['String']['input'];
}>;

export type ExperimentHypothesisSuggestionQuery = { __typename?: 'Query'; experiment_hypothesis_suggestion: string };

export type GetServiceSettingsQueryVariables = Types.Exact<{
  service_id: Types.Scalars['Int64ID']['input'];
  project_id: Types.Scalars['StringID']['input'];
}>;

export type GetServiceSettingsQuery = {
  __typename?: 'Query';
  serviceSettings?: {
    __typename?: 'ServiceSettings';
    serviceID: any;
    projectID: string;
    rootSpanFilter?: string | null;
  } | null;
};

export const namedOperations = {
  Query: {
    GetNetworkHistogram: 'GetNetworkHistogram' as const,
    GetSessionPayload: 'GetSessionPayload' as const,
    GetEventChunkURL: 'GetEventChunkURL' as const,
    GetEventChunks: 'GetEventChunks' as const,
    GetSession: 'GetSession' as const,
    GetWorkspaceAdminsByProjectId: 'GetWorkspaceAdminsByProjectId' as const,
    GetWorkspaceAdmins: 'GetWorkspaceAdmins' as const,
    GetSessionInsight: 'GetSessionInsight' as const,
    GetSessionExports: 'GetSessionExports' as const,
    GetSessionComments: 'GetSessionComments' as const,
    isSessionPending: 'isSessionPending' as const,
    GetSessionIntervals: 'GetSessionIntervals' as const,
    GetTimelineIndicatorEvents: 'GetTimelineIndicatorEvents' as const,
    GetSessionChunkPreviewFrames: 'GetSessionChunkPreviewFrames' as const,
    GetWebSocketEvents: 'GetWebSocketEvents' as const,
    GetSessions: 'GetSessions' as const,
    GetEventSessions: 'GetEventSessions' as const,
    GetSessionsHistogram: 'GetSessionsHistogram' as const,
    GetSessionUsersReports: 'GetSessionUsersReports' as const,
    GetErrorGroups: 'GetErrorGroups' as const,
    GetErrorGroupsForFlagVariation: 'GetErrorGroupsForFlagVariation' as const,
    GetErrorsHistogram: 'GetErrorsHistogram' as const,
    GetProjects: 'GetProjects' as const,
    GetWorkspace: 'GetWorkspace' as const,
    GetWorkspaceForInviteLink: 'GetWorkspaceForInviteLink' as const,
    GetWorkspaces: 'GetWorkspaces' as const,
    GetWorkspacesCount: 'GetWorkspacesCount' as const,
    GetProjectsAndWorkspaces: 'GetProjectsAndWorkspaces' as const,
    GetProjectOrWorkspace: 'GetProjectOrWorkspace' as const,
    GetDropdownOptions: 'GetDropdownOptions' as const,
    GetAdmin: 'GetAdmin' as const,
    GetAdminRole: 'GetAdminRole' as const,
    GetAdminRoleByProject: 'GetAdminRoleByProject' as const,
    GetAdminAboutYou: 'GetAdminAboutYou' as const,
    GetProject: 'GetProject' as const,
    GetBillingDetailsForProject: 'GetBillingDetailsForProject' as const,
    GetWorkspaceUsageHistory: 'GetWorkspaceUsageHistory' as const,
    GetBillingDetails: 'GetBillingDetails' as const,
    GetSubscriptionDetails: 'GetSubscriptionDetails' as const,
    GetErrorGroup: 'GetErrorGroup' as const,
    GetErrorObjectForLog: 'GetErrorObjectForLog' as const,
    GetErrorObject: 'GetErrorObject' as const,
    GetErrorInstance: 'GetErrorInstance' as const,
    GetResources: 'GetResources' as const,
    GetProjectSuggestion: 'GetProjectSuggestion' as const,
    GetSavedSegments: 'GetSavedSegments' as const,
    GetClientIntegration: 'GetClientIntegration' as const,
    GetServerIntegration: 'GetServerIntegration' as const,
    GetLogsIntegration: 'GetLogsIntegration' as const,
    GetTracesIntegration: 'GetTracesIntegration' as const,
    GetMetricsIntegration: 'GetMetricsIntegration' as const,
    GetKeyPerformanceIndicators: 'GetKeyPerformanceIndicators' as const,
    GetReferrersCount: 'GetReferrersCount' as const,
    GetNewUsersCount: 'GetNewUsersCount' as const,
    GetAverageSessionLength: 'GetAverageSessionLength' as const,
    GetTopUsers: 'GetTopUsers' as const,
    GetDailySessionsCount: 'GetDailySessionsCount' as const,
    GetDailyErrorsCount: 'GetDailyErrorsCount' as const,
    GetRageClicksForProject: 'GetRageClicksForProject' as const,
    GetDailyErrorFrequency: 'GetDailyErrorFrequency' as const,
    GetSlackChannelSuggestion: 'GetSlackChannelSuggestion' as const,
    GetWorkspaceIsIntegratedWithSlack: 'GetWorkspaceIsIntegratedWithSlack' as const,
    GetWorkspaceIsIntegratedWithCloudflare: 'GetWorkspaceIsIntegratedWithCloudflare' as const,
    GetJiraIntegrationSettings: 'GetJiraIntegrationSettings' as const,
    GetGitHubIntegrationSettings: 'GetGitHubIntegrationSettings' as const,
    GetVegaIntegrationStatus: 'GetVegaIntegrationStatus' as const,
    GetGitlabIntegrationSettings: 'GetGitlabIntegrationSettings' as const,
    GetGitHubIssueLabels: 'GetGitHubIssueLabels' as const,
    GetProjectIntegratedWith: 'GetProjectIntegratedWith' as const,
    GetIdentifierSuggestions: 'GetIdentifierSuggestions' as const,
    GetServiceAlerts: 'GetServiceAlerts' as const,
    GetAlertsPagePayload: 'GetAlertsPagePayload' as const,
    GetAlert: 'GetAlert' as const,
    GetAlertingAlertStateChanges: 'GetAlertingAlertStateChanges' as const,
    GetLastAlertStateChanges: 'GetLastAlertStateChanges' as const,
    GetLastAlertingStateChange: 'GetLastAlertingStateChange' as const,
    GetAlertingAlertGroupStates: 'GetAlertingAlertGroupStates' as const,
    GetLastAlertGroupStates: 'GetLastAlertGroupStates' as const,
    GetLastAlertingAlertGroupState: 'GetLastAlertingAlertGroupState' as const,
    GetCustomerPortalURL: 'GetCustomerPortalURL' as const,
    GetWebVitals: 'GetWebVitals' as const,
    GetSourcemapFiles: 'GetSourcemapFiles' as const,
    GetSourcemapVersions: 'GetSourcemapVersions' as const,
    GetOAuthClientMetadata: 'GetOAuthClientMetadata' as const,
    GetSSOLogin: 'GetSSOLogin' as const,
    SearchIssues: 'SearchIssues' as const,
    GetErrorGroupTags: 'GetErrorGroupTags' as const,
    GetEmailOptOuts: 'GetEmailOptOuts' as const,
    GetLogs: 'GetLogs' as const,
    GetLogsHistogram: 'GetLogsHistogram' as const,
    GetLogsRelatedResources: 'GetLogsRelatedResources' as const,
    GetProjectSettings: 'GetProjectSettings' as const,
    GetWorkspacePendingInvites: 'GetWorkspacePendingInvites' as const,
    GetErrorResolutionSuggestion: 'GetErrorResolutionSuggestion' as const,
    GetWorkspaceSettings: 'GetWorkspaceSettings' as const,
    GetSystemConfiguration: 'GetSystemConfiguration' as const,
    GetErrorGroupInstances: 'GetErrorGroupInstances' as const,
    GetErrorObjects: 'GetErrorObjects' as const,
    GetServices: 'GetServices' as const,
    GetServiceByName: 'GetServiceByName' as const,
    GetTrace: 'GetTrace' as const,
    GetTraceConversation: 'GetTraceConversation' as const,
    GetTraces: 'GetTraces' as const,
    GetTraceSummaries: 'GetTraceSummaries' as const,
    GetConversations: 'GetConversations' as const,
    GetTracesMetrics: 'GetTracesMetrics' as const,
    GetKeys: 'GetKeys' as const,
    GetKeyValues: 'GetKeyValues' as const,
    GetKeyValueSuggestions: 'GetKeyValueSuggestions' as const,
    GetValueSuggestions: 'GetValueSuggestions' as const,
    GetUrlKeyValues: 'GetUrlKeyValues' as const,
    GetMetrics: 'GetMetrics' as const,
    GetGraphTemplates: 'GetGraphTemplates' as const,
    GetVisualization: 'GetVisualization' as const,
    GetVisualizations: 'GetVisualizations' as const,
    GetAIQuerySuggestion: 'GetAIQuerySuggestion' as const,
    GetHeatmapClicks: 'GetHeatmapClicks' as const,
    GetTimestampEventChunkURL: 'GetTimestampEventChunkURL' as const,
    GetConversationHistory: 'GetConversationHistory' as const,
    GetClickSessions: 'GetClickSessions' as const,
    GetAiChatLimitStatus: 'GetAiChatLimitStatus' as const,
    GetFilterRules: 'GetFilterRules' as const,
    GetQueryFilterRule: 'GetQueryFilterRule' as const,
    GetServiceMap: 'GetServiceMap' as const,
    GetTraceServiceSummary: 'GetTraceServiceSummary' as const,
    GetServiceConnections: 'GetServiceConnections' as const,
    GetAiConversationHistory: 'GetAiConversationHistory' as const,
    GetAgentArtifact: 'GetAgentArtifact' as const,
    GetProjectArtifacts: 'GetProjectArtifacts' as const,
    GetConversationArtifacts: 'GetConversationArtifacts' as const,
    GetFlagCleanups: 'GetFlagCleanups' as const,
    GetVegaSlackConfiguration: 'GetVegaSlackConfiguration' as const,
    GetVegaProjectConfiguration: 'GetVegaProjectConfiguration' as const,
    GetDashboardOptions: 'GetDashboardOptions' as const,
    GetGraphOptions: 'GetGraphOptions' as const,
    GetAlertOptions: 'GetAlertOptions' as const,
    GetPAEvents: 'GetPAEvents' as const,
    GetPaEventsFunnel: 'GetPaEventsFunnel' as const,
    GetPaEventsFunnelV2: 'GetPaEventsFunnelV2' as const,
    GetTeamQueryHistory: 'GetTeamQueryHistory' as const,
    GetMetricExemplars: 'GetMetricExemplars' as const,
    ExperimentHypothesisSuggestion: 'ExperimentHypothesisSuggestion' as const,
    GetServiceSettings: 'GetServiceSettings' as const,
  },
  Mutation: {
    MarkErrorGroupAsViewed: 'MarkErrorGroupAsViewed' as const,
    MarkSessionAsViewed: 'MarkSessionAsViewed' as const,
    updateErrorGroupState: 'updateErrorGroupState' as const,
    AddIntegrationToProject: 'AddIntegrationToProject' as const,
    RemoveIntegrationFromProject: 'RemoveIntegrationFromProject' as const,
    AddIntegrationToWorkspace: 'AddIntegrationToWorkspace' as const,
    RemoveIntegrationFromWorkspace: 'RemoveIntegrationFromWorkspace' as const,
    SubmitRegistrationForm: 'SubmitRegistrationForm' as const,
    EditProjectSettings: 'EditProjectSettings' as const,
    CreateAlert: 'CreateAlert' as const,
    UpdateAlert: 'UpdateAlert' as const,
    UpdateAlertDisabled: 'UpdateAlertDisabled' as const,
    DeleteAlert: 'DeleteAlert' as const,
    TestAlertConfiguration: 'TestAlertConfiguration' as const,
    UpdateSessionIsPublic: 'UpdateSessionIsPublic' as const,
    UpdateErrorGroupIsPublic: 'UpdateErrorGroupIsPublic' as const,
    UpdateAllowMeterOverage: 'UpdateAllowMeterOverage' as const,
    SyncSlackIntegration: 'SyncSlackIntegration' as const,
    DeleteSessions: 'DeleteSessions' as const,
    ExportSession: 'ExportSession' as const,
    UpdateIntegrationProjectSettings: 'UpdateIntegrationProjectSettings' as const,
    EditServiceGithubSettings: 'EditServiceGithubSettings' as const,
    UpsertSlackChannel: 'UpsertSlackChannel' as const,
    testErrorEnhancement: 'testErrorEnhancement' as const,
    DeleteSavedSegment: 'DeleteSavedSegment' as const,
    EditSavedSegment: 'EditSavedSegment' as const,
    CreateSavedSegment: 'CreateSavedSegment' as const,
    UpsertVisualization: 'UpsertVisualization' as const,
    DeleteVisualization: 'DeleteVisualization' as const,
    UpsertGraph: 'UpsertGraph' as const,
    DeleteGraph: 'DeleteGraph' as const,
    CreateCloudflareProxy: 'CreateCloudflareProxy' as const,
    AgentPrompt: 'AgentPrompt' as const,
    FlagCleanupPrompt: 'FlagCleanupPrompt' as const,
    PricingConciergePrompt: 'PricingConciergePrompt' as const,
    StopAgent: 'StopAgent' as const,
    UpsertVegaSlackConfiguration: 'UpsertVegaSlackConfiguration' as const,
    UpsertVegaProjectConfiguration: 'UpsertVegaProjectConfiguration' as const,
    CreateQueryFilterRule: 'CreateQueryFilterRule' as const,
    UpdateQueryFilterRule: 'UpdateQueryFilterRule' as const,
    DeleteQueryFilterRule: 'DeleteQueryFilterRule' as const,
    UpdateFilterSettings: 'UpdateFilterSettings' as const,
    ShareConversation: 'ShareConversation' as const,
    TagConversation: 'TagConversation' as const,
    SignAiTermsRecord: 'SignAiTermsRecord' as const,
    CreateJiraIssueForAlert: 'CreateJiraIssueForAlert' as const,
    CreateJiraIssueForErrorGroup: 'CreateJiraIssueForErrorGroup' as const,
    CreateJiraIssueForSession: 'CreateJiraIssueForSession' as const,
    ExperimentHypothesisBuilderAssist: 'ExperimentHypothesisBuilderAssist' as const,
    EditServiceSettings: 'EditServiceSettings' as const,
  },
  Subscription: {
    OnSessionPayloadAppended: 'OnSessionPayloadAppended' as const,
  },
  Fragment: {
    SessionPayloadFragment: 'SessionPayloadFragment' as const,
    ErrorObject: 'ErrorObject' as const,
    Project: 'Project' as const,
  },
};
